import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  NgModel,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import {
  addMonths,
  differenceInCalendarMonths,
  format,
  getDate,
  lastDayOfMonth,
  parse,
  setDate,
} from "date-fns";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import { Lightbox } from "ngx-lightbox";
import { Observable } from "rxjs/Observable";
import swal from "sweetalert2";
import { ProjectsService } from "../services/projects/projects.service";
import { environment } from "./../../environments/environment";
import { LeadsService } from "./../services/lead-service/lead-service.service";
import { MarketingService } from "./../services/marketing/marketing.service";
import { ReservationService } from "./../services/reservation-service/reservation.service";
import { ErrorHandlerService } from "./../services/shared/error-handler.service";
import { UserServiceService } from "./../services/user-service/user-service.service";

@Component({
  selector: "app-reservation-view",
  templateUrl: "./reservation-view.component.html",
  styleUrls: ["./reservation-view.component.css"],
})
export class ReservationViewComponent implements OnInit {
  ListEdits_inputs = false;
  methods: any;
  reservation_details: any;
  userProfile: any;
  chosenAgent: any;
  dataFromSearch: any;
  arrSearch: any;
  selling_price: any;
  selling_date: any;
  confirmation_date: any;
  commentReservation: any;
  installmentForm: FormGroup;
  installmentMethods: any;
  installmentDays: any = [];
  is_refreshing = false;
  doc_type_installment_modal: any = ["PDF", "Excel"];
  is_installment_modal_loading = false;
  payments_option = ["Quarter", "Semi-annual", "Annual"];
  last_price: any;
  cfo_pin: any;
  filesForm: FormGroup;
  filterForm: FormGroup;
  uploadExcel: FormGroup;
  file_name: any;
  file_name2: any;
  signature_date: any;
  chosenLeadID: any;
  leadArrSerach: any;
  chosenLead: any;
  chosenClient: any = {};
  chosenLeadReason: any;
  chosenLeadPhone: any;
  chosenLeadName: any;
  chosenLeadNationalityID: any;
  chosenLeadNationality: any;
  chosenLeadDistrict: any;
  chosenLeadIssueDate: any;
  chosenLeadCivilRegistery: any;
  chosenLeadBirthday: any;
  chosenLeadAddress: any;
  filterAgentByWordText: any;
  percentage: any;
  refundReason: any;
  type_extra_discount: any = "percentage";
  value_extra_discount: any;
  reason: any;
  down_payment: any;
  deal_types: any = ["Direct", "In-Direct"];
  direct_option: any = ["Individual"];
  ambassadors: any;
  brokers: any;
  deal_type: any;
  commission_date: any;
  active_cheque_book_row: any;
  representative_id;

  claim_form = {
    claim_date: "",
    claim_from: "",
  };

  // ------------add-customer decl------------
  customersData: any;
  chosenCustomer;
  addCustomerForm = {
    lead_id: "",
    lead_name: "",
    lead_phone: "",
    lead_email: "",
    lead_national_id: "",
    lead_nationality: "",
    lead_other_phone: "",
    lead_birthday: "",
    lead_address: "",
    lead_district: "",
    sharing_percentage: "",
    customer_type: "",
  };

  addCustomerRepresentativeForm = {
    representative_name: "",
    representative_national_id: "",
    representative_national_office: "",
    representative_national_governorate: "",
    representative_national_date: "",
    representative_national_serial: "",
    representative_address: "",
    representative_department: "",
    representative_governorate: "",
    power_of_attorney_number: "",
    power_of_attorney_year: "",
    power_of_attorney_office: "",
    power_of_attorney_date: "",
  };
  staticLeads = [
    {
      created_at: "2021-12-01 13:44:03",
      id: 225,
      lead_address: null,
      lead_birthday: null,
      lead_district: null,
      lead_email: null,
      lead_fax_number: null,
      lead_home_phone: null,
      lead_issue_date: null,
      lead_job_title: null,
      lead_marital_status: null,
      lead_name: "Ali .syed",
      lead_national_id: null,
      lead_nationality: null,
      lead_other_phone: null,
      lead_phone: "96550747384",
      lead_work_address: null,
      lead_workplace: null,
      reservation_id: 250,
      sharing_percentage: 100,
      updated_at: "2021-12-01 13:44:03",
    },
    {
      created_at: "2021-12-01 13:44:03",
      id: 225,
      lead_address: null,
      lead_birthday: null,
      lead_district: null,
      lead_email: null,
      lead_fax_number: null,
      lead_home_phone: null,
      lead_issue_date: null,
      lead_job_title: null,
      lead_marital_status: null,
      lead_name: "Ali .syed",
      lead_national_id: null,
      lead_nationality: null,
      lead_other_phone: null,
      lead_phone: "96550747384",
      lead_work_address: null,
      lead_workplace: null,
      reservation_id: 250,
      sharing_percentage: 100,
      updated_at: "2021-12-01 13:44:03",
    },
    {
      created_at: "2021-12-01 13:44:03",
      id: 225,
      lead_address: null,
      lead_birthday: null,
      lead_district: null,
      lead_email: null,
      lead_fax_number: null,
      lead_home_phone: null,
      lead_issue_date: null,
      lead_job_title: null,
      lead_marital_status: null,
      lead_name: "Ali .syed",
      lead_national_id: null,
      lead_nationality: null,
      lead_other_phone: null,
      lead_phone: "96550747384",
      lead_work_address: null,
      lead_workplace: null,
      reservation_id: 250,
      sharing_percentage: 100,
      updated_at: "2021-12-01 13:44:03",
    },
  ];
  customer_id;
  single_customer;
  refundReasons: any = [
    "Financial issue",
    "Personal issue",
    "Legal action",
    "Activate by Mistake",
    "Contract details",
    "Rejected Cheques",
    "transfer to another unit",
  ];
  garageSlots: any;
  slots = {
    service_room_slots: 0,
    service_room_with_bathroom_slots: 0,
  };
  last_payment_type: any;
  is_overseas: any;
  slip_number: any;
  cheque_number: any;
  due_date: any;
  commission_to: any;
  cash: any;
  ev: any;
  installment_delay: any;
  type = "6 years";
  paymentForm: FormGroup;
  payment_term_id: any;

  selling_price_in_modal: any;

  edit_lead_data = {
    lead_id: "",
    lead_name: "",
    lead_phone: "",
    lead_email: "",
    lead_national_id: "",
    lead_nationality: "",
    lead_other_phone: "",
    lead_birthday: "",
    lead_address: "",
    lead_district: "",
    lead_phone2: "",
    sharing_percentage: "",
    customer_type: "",
    lead_phone_3: "",
    lead_phone_4: "",
  };

  contractForm: FormGroup;

  cancel_reason: any;
  cancel_date: any;

  agents: any;

  agent_in_charge: any;

  contract_type_details = {
    contract_type: "",
    rent_value: "",
    rent_start_date: "",
    rent_end_date: "",
    rent_years_num: "",
    payment_type: "",
    is_overseas: "",
    installment_years: "",
    // installment_fees: "",
  };
  payment_plans: any;
  _staticMasterPlanImages: any;

  currentSlide: any;

  payment_collections_list = [
    {
      name: "test",
      rf_serial: "test",
      unit_serial: "test",
      date: "2020-10-13 19:51:01",
      status: "test",
      is_collected: true,
    },
    {
      name: "test",
      rf_serial: "test",
      unit_serial: "test",
      date: "2020-10-13 19:51:01",
      status: "test",
      is_collected: true,
    },
    {
      name: "test",
      rf_serial: "test",
      unit_serial: "test",
      date: "2020-10-13 19:51:01",
      status: "test",
      is_collected: false,
    },
    {
      name: "test",
      rf_serial: "test",
      unit_serial: "test",
      date: "2020-10-13 19:51:01",
      status: "test",
      is_collected: false,
    },
    {
      name: "test",
      rf_serial: "test",
      unit_serial: "test",
      date: "2020-10-13 19:51:01",
      status: "test",
      is_collected: false,
    },
    {
      name: "test",
      rf_serial: "test",
      unit_serial: "test",
      date: "2020-10-13 19:51:01",
      status: "test",
      is_collected: false,
    },
    {
      name: "test",
      rf_serial: "test",
      unit_serial: "test",
      date: "2020-10-13 19:51:01",
      status: "test",
      is_collected: false,
    },
    {
      name: "test",
      rf_serial: "test",
      unit_serial: "test",
      date: "2020-10-13 19:51:01",
      status: "test",
      is_collected: false,
    },
  ];

  partially_methods = [
    "Cash",
    "Visa",
    "Transfer",
    "Cheque",
    "Commission Settlement",
    "Share Holder Settlement",
    "Vendor Settlement",
  ];

  sharedAgentsCommissionsView: any;
  sharedAgentsCommissions: FormArray = new FormArray([]);
  disable_save_shared_comission = false;

  oversea_contract_sent_date: any = new Date();

  payment_type: any = "down_payment";
  slip_type: any;
  slip_customer: any;
  deposit_amount: any;

  complete_down_payment_amount: any;

  banks: any;
  bank_id: any;
  store_status: any;

  documentForm: FormGroup;
  documents: any;

  add_cheque = {
    name: "",
    bank_id: "", // done
    store_status: "", // done
    cheque_number: "", // done
    amount: "", // done
    amount_received: "0",
    transaction_number: "", // done
    date: new Date(), // done
    type: 1,
    // fixed
    status: "under-collection",
    send_reminder: 1, // done
    print_status: 1, // done
  };

  contract_signed_by_client_date: any;
  reservation_form_signed_date: any;
  contract_approve_date: any;
  contract_dilever_date: any;

  cheque_recieved_date: any;

  /*Payment collection variables Start*/
  payment_collections: any;
  pageTest = 1;
  /*Payment collection variables End*/

  reservationFiles = [];
  finalPaymentPlanFile;
  isReadonlyMode = false;
  reservationId;
  currentRole = "";
  isAccountant = false;
  divisionForm: any = {};

  // cheques book
  enable_edit_payment_collections = false;
  disableSavePaymentCollection = false;
  check_all = false;
  current_active_cheque: number;
  current_active_full_cheque: any;
  enableRemiderType: string;
  disableReminderType: string;
  chequeCollectType: any;
  chequeCollectCustomer: any;
  collect_type = "fully-collected";
  collection_date = "";
  chequeRejectType: any;

  developer_id: number;
  name_on_cheques: string;
  cheque_book_name: string;

  reminder_reason: string;

  uploadScannedChequeForm: FormGroup;

  reject_reason: any;
  reject_comment: string;
  cheque_amount: any;

  partially_method: any;
  partially_data: any;
  exchange_rate: any;

  addContractLog = {
    reservation_id: "",
    agent_id: "",
    delivered_at: "",
    status: "",
    details: "",
  };

  developers: any;
  events = [];

  store_banks: any;

  fines: any;
  collect_type_fines = "fully-collected";
  collection_date_fines = "";
  chequeCollectTypeFine: any;
  chequeCollectCustomerFines: any;
  current_active_cheque_fine: number;
  partially_method_fines: any;
  partially_data_fines: any;
  cheque_amount_fines: any;
  currency_code: any = "EGP";

  currencies_list = [];

  chequeRejectTypeFine: any;

  cheque_amount_fine = null;
  reject_reason_fine = null;
  reject_comment_fine = null;

  totalChequeBookAmount = 0;
  totalCDBAmount = 0;

  eoiDataFromSearch: any;
  eoisArrSearch: any;
  chosen_eoi: any;
  chosenEoi: any;

  location_bounce;

  transaction_number: any;

  add_bulk_cheque_amount: string;

  commission_settlement_user_id: number;
  share_holder_name: string;

  redeposit_date: string;

  request_reason: string;
  request_date: string;
  request_type: string;
  request_ids: number[];

  reject_reasons: any;

  bounce_date: any;

  reason_exclude_from_calculation: string[] = [
    "Cancelation-Visa Payment",
    "Cancelation-Cash Payment",
    "Cancelation-Transfer Payment",
    "Transfer of ownership",
    "Client Death",
    "Early Payment",
  ];

  nationalities: any = [];

  constructor(
    private slimLoadingBarService: SlimLoadingBarService,
    private reservationService: ReservationService,
    private errorHandlerService: ErrorHandlerService,
    private http: HttpClient,
    private fb: FormBuilder,
    private userService: UserServiceService,
    private leadsService: LeadsService,
    private _lightbox: Lightbox,
    private projectsService: ProjectsService,
    private marketingService: MarketingService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.createDivisionForm();
  }

  ngOnInit() {
    this.getRejectReaasons();
    this.getdevelopers();
    this.getChannels();
    this.getEvents();
    this.getStoreBanks();
    this.getAllCurrencies();
    this.userProfile = JSON.parse(window.localStorage.getItem("userProfile"));
    this.currentRole = window.localStorage.getItem("role");
    if (
      this.currentRole &&
      (this.currentRole == "A.R Accountant" ||
        this.currentRole == "G.L Accountant" ||
        this.currentRole == "Treasury Accountant")
    )
      this.isAccountant = true;
    this.getQParams();
    this.getParams();
    this.getNationalities();
  }

  getAllCurrencies() {
    this.slimLoadingBarService.start();
    this.reservationService.getAllCurrencies().subscribe(
      (data: any) => {
        this.currencies_list = data;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }
  getStoreBanks() {
    this.slimLoadingBarService.start();
    this.userService.getBanks().subscribe(
      (data: any) => {
        this.store_banks = data;
        console.log(this.banks);
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getEvents() {
    this.slimLoadingBarService.start();
    this.reservationService.getAllEvents().subscribe(
      (res: any) => {
        console.log(res);
        this.events = res;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getParams() {
    this.createInstallmentForm();
    this.activatedRoute.params.subscribe((res) => {
      if (res["id"]) this.reservationId = res["id"];
      else {
        this.reservationId = JSON.parse(
          window.localStorage.getItem("reservationDetails")
        ).id;
      }

      this.createDocumentForm();
      this.createPaymentForm();
      this.createFilesUploadForm();
      this.getReservation();
    });
  }

  getQParams() {
    this.activatedRoute.queryParams.subscribe(
      (res) => (this.isReadonlyMode = res["ro"] == 1)
    );
  }

  channels: any;
  leadSources = [];

  require_channels = [];
  getChannels() {
    this.slimLoadingBarService.start();
    this.marketingService.getChannels().subscribe(
      (res: any) => {
        this.channels = res;
        this.require_channels.map((a) => a());
        this.require_channels = null;
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  channelChange(change = true) {
    if (change) {
      this.divisionForm.lead_source = -1;
    }
    if (Array.isArray(this.require_channels)) {
      this.require_channels.push(() => {
        this.channels.forEach((e) => {
          if (e.name == this.divisionForm.deal_type) {
            this.leadSources = [];
            if (change) {
              this.divisionForm.deal_category = "";
              this.divisionForm.deal_source = "";
            }
            this.leadSources = e.sources;
            if (change && e.name != "Direct") {
              if (this.divisionForm.broker_id) {
                this.divisionForm.broker_id = null;
              } else if (this.divisionForm.ambassador_id) {
                this.divisionForm.ambassador_id = null;
              }
            }
          }
        });
      });
    } else {
      this.channels.forEach((e) => {
        if (e.name == this.divisionForm.deal_type) {
          this.leadSources = [];
          if (change) {
            this.divisionForm.deal_category = "";
            this.divisionForm.deal_source = "";
          }
          this.leadSources = e.sources;
          if (change && e.name != "Direct") {
            if (this.divisionForm.broker_id) {
              this.divisionForm.broker_id = null;
            } else if (this.divisionForm.ambassador_id) {
              this.divisionForm.ambassador_id = null;
            }
          }
        }
      });
    }
  }

  createPaymentForm() {
    this.paymentForm = this.fb.group({
      percentage: [{ value: "", disabled: true }, Validators.required],
      payment_term_id: ["", Validators.required],
    });
  }
  createDocumentForm() {
    this.documentForm = this.fb.group({
      name: ["", Validators.required],
      document_value: [null],
      document_name: [null],
    });
  }

  onDocumentSubmit() {
    const payload = this.documentForm.value;
    console.log(payload);
    this.slimLoadingBarService.start();
    this.reservationService
      .addDocument(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          swal("Success", "added document successfully", "success");
          this.documentForm.reset();
          this.getReservationsDocuments();
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.slimLoadingBarService.reset();
        }
      );
  }

  getReservationsDocuments() {
    this.slimLoadingBarService.start();
    this.reservationService
      .getReservationDocuments(this.reservation_details.id)
      .subscribe(
        (res: any) => {
          this.documents = res;
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.slimLoadingBarService.reset();
        }
      );
  }

  deleteDocument(id) {
    swal({
      title: "Are you sure?",
      text: "You will delete this document!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .deleteReservationDocument(this.reservation_details.id, id)
          .subscribe(
            (res: any) => {
              swal("Success", "Deleted document successfully", "success");
              this.slimLoadingBarService.complete();
              this.getReservationsDocuments();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  onFileChange(event) {
    // residence_image: ['', Validators.required],
    //   residence_name: ['', Validators.required]
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      this.file_name = file.name;
      reader.onload = () => {
        // this.documentForm.get('image').setValue({
        //   filename: file.name,
        //   filetype: file.type,
        //   value: ((reader.result as any) as any).split(',')[1]
        // });
        this.documentForm
          .get("document_value")
          .patchValue((reader.result as any as any).split(",")[1]);
        this.documentForm.get("document_name").patchValue(file.name);
      };
    }
  }

  createContractForm(data?) {
    if (data.contract_type == "rent") {
      this.contractForm = this.fb.group({
        contract_type: [data.contract_type || ""],
        //rent
        rent_value: [data.rent_details.rent_value || ""],
        rent_start_date: [data.rent_details.rent_start_date || ""],
        rent_end_date: [data.rent_details.rent_end_date || ""],
        rent_years_num: [data.rent_details.rent_years_num || ""],
        // sale
        payment_type: [data.payment_type || ""],
        is_overseas: [data.is_overseas],
        installment_years: [data.installment_years || ""],
        // installment_fees: [data.installment_fees || ""],
      });
    } else {
      this.contractForm = this.fb.group({
        contract_type: [data.contract_type || ""],
        //rent
        rent_value: [""],
        rent_start_date: [""],
        rent_end_date: [""],
        rent_years_num: [""],
        // sale
        payment_type: [data.payment_type || ""],
        is_overseas: [data.is_overseas],
        installment_years: [data.installment_years || ""],
        // installment_fees: [data.installment_fees || ""],
      });
    }
    console.log(this.contractForm.value);
  }

  deleteControl(index) {}

  getSharedComission(id) {
    this.reservationService.getSharedComissions(id).subscribe(
      (res: any) => {
        console.log({ res });
        this.sharedAgentsCommissionsView = res;
        res.forEach((element) => {
          this.addInputsForSharedComissions(element);
        });
      },
      (err) => {
        console.log(err);
      }
    );
  }

  addInputsForSharedComissions(element?) {
    if (element) {
      const group = new FormGroup({
        user_id: new FormControl(element.user_id || null),
        comission_percentage: new FormControl(
          element.comission_percentage || null
        ),
      });
      this.sharedAgentsCommissions.push(group);
    } else {
      const group = new FormGroup({
        user_id: new FormControl(null),
        comission_percentage: new FormControl(null),
      });
      this.sharedAgentsCommissions.push(group);
    }
  }

  saveSharedCommission() {
    console.log(this.sharedAgentsCommissions.value);
    let all_comissions_value = 0;
    const sharedAgentsCommissionsValue = this.sharedAgentsCommissions.value;
    if (sharedAgentsCommissionsValue) {
      sharedAgentsCommissionsValue.forEach((agnet_commision) => {
        all_comissions_value += +agnet_commision.comission_percentage;
      });
    }
    console.log(all_comissions_value);
    if (+all_comissions_value != 100) {
      swal("error", "Total Commission is not equal to 100", "error");
      return;
    } else {
      this.disable_save_shared_comission = true;
      this.slimLoadingBarService.start();
      this.reservationService
        .addShareComission(
          this.reservation_details.id,
          sharedAgentsCommissionsValue
        )
        .subscribe(
          (res: any) => {
            swal("success", "Commissions updated successfully", "success");
            this.disable_save_shared_comission = false;
            this.slimLoadingBarService.complete();
          },
          (err) => {
            this.disable_save_shared_comission = false;
            this.slimLoadingBarService.complete();
            this.errorHandlerService.handleErorr(err);
            console.log(err);
          }
        );
    }
  }

  getAllAgents() {
    this.leadsService.getAgents().subscribe(
      (data: any) => {
        this.agents = data;
        this.slimLoadingBarService.complete();
      },
      (err) => {
        console.log(err);
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  onAgentInChargeSelected(event) {
    const payload = {
      agent_in_charge: this.agent_in_charge,
    };
    this.leadsService
      .changeAgentInCharge(this.reservation_details.id, payload)
      .subscribe(
        (res) => {
          swal("Success", "Agent in charge changed successfully", "success");
          this.getReservation();
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getPaymentTerms() {
    this.userService
      .getPaymentTermsByProject(this.reservation_details.unit.project.id)
      .subscribe(
        (res) => {
          this.methods = res;
        },
        (err) => this.errorHandlerService.handleErorr(err)
      );
  }

  getReservation() {
    this.slimLoadingBarService.start();
    this.reservationService.getSingleReservation(this.reservationId).subscribe(
      (data: any) => {
        this.sharedAgentsCommissions = new FormArray([]);
        console.log("reservation", data.data[0]);
        this.reservation_details = data.data[0];
        this.getSharedComission(this.reservation_details.id);
        this.cheque_recieved_date =
          this.reservation_details.cheque_recieved_date;
        this.cancel_reason = this.reservation_details.cancel_reason;
        this.cancel_date = this.reservation_details.cancel_date;
        this.getChequesTempaltes();
        // this.deal_type_change();
        this.getAmbassadors();
        this.getBrokers();
        this.getAllAgents();
        this.getReservationsDocuments();
        this.down_payment =
          this.reservation_details.unit_price *
          (this.reservation_details.percentage / 100);
        // this.getPaymentTerms();
        if (this.reservation_details.unit.layout_images) {
          if (this.reservation_details.unit.layout_images.length) {
            this.currentSlide = 0;
          }
        }
        this.createContractForm(this.reservation_details);
        const payload = {
          project_id: this.reservation_details.project_id,
          phase_id: this.reservation_details.phase_id,
          finishing_type_id: this.reservation_details.finishing_type_id,
        };
        this.getPaymentTermsByProjectId(
          {project_id: this.reservation_details.unit.project_id}
        );
        this.edit_lead_data.lead_address =
          this.reservation_details.lead_address;
        this.edit_lead_data.lead_birthday =
          this.reservation_details.lead_birthday;
        this.edit_lead_data.lead_district =
          this.reservation_details.lead_district;
        this.edit_lead_data.lead_national_id =
          this.reservation_details.lead_national_id;
        this.edit_lead_data.lead_nationality =
          this.reservation_details.lead_nationality;
        if (this.reservation_details.lead) {
          this.edit_lead_data.lead_name = this.reservation_details.lead.name;
          this.edit_lead_data.lead_email = this.reservation_details.lead.email;
          this.edit_lead_data.lead_phone = this.reservation_details.lead.phone;
          this.edit_lead_data.lead_phone2 =
            this.reservation_details.lead.phone_2;
          this.edit_lead_data.lead_phone_3 =
            this.reservation_details.lead.phone_3;
          this.edit_lead_data.lead_phone_4 =
            this.reservation_details.lead.phone_4;
          this.edit_lead_data.customer_type =
            this.reservation_details.lead.customer_type;
        }
        this.selling_price_in_modal = this.reservation_details.unit_price;
        this.installmentDays = [];
        this.agent_in_charge = this.reservation_details.agent_in_charge;

        //   let agentsArr = [];
        //   this.leadsService.getAgents().subscribe(
        //     (data: any) => {
        //       agentsArr = data;
        //     });
        //   for (let i = 0; i <= agentsArr.length; i++) {
        //     if (agentsArr[i].id === 1) {
        //         this.agents.push({ label: this.agents[i].name, value: this.agents[i].id });
        //     }
        // }

        //   this.agents.forEach(
        //     (agent)=> {
        //         this.agents.push({label: agent.name, value: agent.id});
        //         console.log(agent);
        //         this.agent_in_charge = agent.id;
        //     }
        // );

        console.log("sasa", this.agent_in_charge);

        for (let i = 1; i < 29; i++) {
          this.installmentDays.push(i);
        }
        this.down_payment =
          this.reservation_details.unit_price *
          (this.reservation_details.percentage / 100);
        console.log(this.reservation_details);
        console.log(this.installmentMethods);
        this.last_payment_type = this.reservation_details.payment_type;
        this.is_overseas = this.reservation_details.is_overseas;
        this.getPaymentCollection(this.reservation_details.id);
        this.getFines(this.reservation_details.id);
        this.installmentForm.patchValue({
          type: this.reservation_details.installment_years,
          percentage: this.reservation_details.percentage,
        });
        console.log(this.installmentForm.value);
        this.divisionForm.deal_type = this.reservation_details.deal_type;
        this.divisionForm.deal_category =
          this.reservation_details.deal_category;
        this.divisionForm.deal_source = this.reservation_details.lead_source;
        if (this.reservation_details.lead_source == "Ambassador") {
          this.divisionForm.ambassador_id =
            this.reservation_details.ambassador_id;
        } else if (this.reservation_details.lead_source == "Broker") {
          this.divisionForm.broker_id = this.reservation_details.broker_id;
        }
        this.channelChange(false);

        this.reservation_details.users = this.sortUsers(
          this.reservation_details.users
        );
        this.slots = {
          service_room_slots: this.reservation_details.service_room_slots,
          service_room_with_bathroom_slots:
            this.reservation_details.service_room_with_bathroom_slots,
        };
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  sortUsers(users) {
    const sorted = [];
    ["Property Consultant", "Team Leader"].map((title) => {
      const index = users.findIndex((user) => user.role === title);
      if (index > -1) {
        sorted.push(users[index]);
        users.splice(index, 1);
      }
    });

    sorted.push(...users);
    return sorted;
  }

  createFilesUploadForm() {
    this.filesForm = this.fb.group({
      receipt: [null, Validators.required],
      signed: [null, Validators.required],
      date: [null, Validators.required],
    });

    this.uploadScannedChequeForm = this.fb.group({
      scannedCheque: [null, Validators.required],
    });

    this.filterForm = this.fb.group({
      serial: [""],
      agent: [""],
      lead_name: [""],
    });

    this.uploadExcel = this.fb.group({
      file: [null, Validators.required],
    });
  }

  filterLeadObservable = (keyword: any): any => {
    const baseUrl: string = environment.api_base_url;
    console.log(baseUrl);
    if (keyword) {
      return this.http
        .get(`${baseUrl}users/search?keyword=${keyword}`)
        .map((res: any) => {
          console.log(res.length);
          if (res.length == 0) {
            return Observable.of([]);
          } else {
            this.arrSearch = [];
            this.dataFromSearch = res;
            res.forEach((e) => {
              this.arrSearch.push(e.name);
            });
            console.log(this.arrSearch);
            return this.arrSearch;
          }
        });
    } else {
      return Observable.of([]);
    }
  };

  valueChanged(event) {
    this.dataFromSearch.forEach((e) => {
      if (e.name == event) this.chosenAgent = e;
    });
  }

  contractSignedByClientModalSubmit(modal) {
    const payload = {
      date: this.contract_signed_by_client_date,
    };
    modal.close();
    this.slimLoadingBarService.start();
    this.reservationService
      .contract_sign_by_client(this.reservation_details.id, payload)
      .subscribe(
        (data) => {
          this.getReservation();
          swal("Woohoo!", "Contract signed by client succesfully!", "success");
        },
        (err) => console.log(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  reservation_form_signedSubmit(modal) {
    const payload = {
      date: this.reservation_form_signed_date,
    };
    modal.close();
    this.slimLoadingBarService.start();
    this.reservationService
      .reservation_form_signed(this.reservation_details.id, payload)
      .subscribe(
        (data) => {
          this.getReservation();
          swal("Woohoo!", "Reservation Form signed succesfully!", "success");
        },
        (err) => console.log(err),
        () => this.slimLoadingBarService.complete()
      );
  }
  contractApproveModalSubmit(modal) {
    const payload = {
      date: this.contract_approve_date,
    };
    modal.close();
    this.slimLoadingBarService.start();
    this.reservationService
      .contract_approve(this.reservation_details.id, payload)
      .subscribe(
        (data) => {
          this.getReservation();
          swal("Woohoo!", "Contract approved succesfully!", "success");
        },
        (err) => console.log(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  contractDileveredModalSubmit(modal) {
    const payload = {
      date: this.contract_dilever_date,
    };
    modal.close();
    this.slimLoadingBarService.start();
    this.reservationService
      .contract_delivered(this.reservation_details.id, payload)
      .subscribe(
        (data) => {
          this.getReservation();
          swal("Woohoo!", "Contract delivered succesfully!", "success");
        },
        (err) => console.log(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  adminDecline(reservationId, modal) {
    swal({
      title: "Are you sure?",
      text: "You will decline the reservation!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, decline it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        if (this.reservation_details.authorization.can_refund_reason == 1) {
          modal.open();
          console.log("success");
        } else {
          console.log("err");
          // this.reservationService.adminDecline(reservationId, {}).subscribe(data => {
          //   swal('Woohoo!', 'Declined Successfully!', 'success');
          //   this.getReservation();
          // }, err => this.errorHandlerService.handleErorr(err));
        }
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  swalDelete(res_id) {
    swal({
      title: "Are you sure?",
      text: "You will not be able to recover this reservation!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService.deleteReservation(res_id).subscribe(
          (data) => {
            this.slimLoadingBarService.complete();
            swal("Deleted!", "Reservation has been deleted.", "success");
            // this.getReservation();
            this.router.navigateByUrl("/pages/reservations");
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.complete();
          }
        );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  accountDecline(reservationId) {
    swal({
      title: "Are you sure?",
      text: "You will decline the reservation!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, decline it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .accountDeclineReservation(reservationId)
          .subscribe(
            (data) => {
              console.log(data);
              this.getReservation();
              swal("Woohoo!", "Declined succesfully!", "success");
            },
            (err) => this.errorHandlerService.handleErorr(err),
            () => this.slimLoadingBarService.complete()
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  cheque_recieved_submit(modal) {
    const data = {
      date: this.cheque_recieved_date,
    };
    this.slimLoadingBarService.start();
    this.reservationService
      .cheque_recieved(this.reservation_details.id, data)
      .subscribe(
        () => {
          modal.close();
          this.getReservation();
          swal("Woohoo!", "cheque Received succesfully!", "success");
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  cancel_cheque_recieved(reservation_id) {
    swal({
      title: "Are you sure?",
      text: "cheque Received Will be Cancelled!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .cancel_cheque_recieved(reservation_id)
          .subscribe(
            (data) => {
              this.getReservation();
              swal(
                "Woohoo!",
                "cheque Recieved Cancelled succesfully!",
                "success"
              );
            },
            (err) => console.log(err),
            () => this.slimLoadingBarService.complete()
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  /***
   * start of assign modal
   */

  closeAssignModal() {}

  submitAssignModal(res_id, modal) {
    this.slimLoadingBarService.start();
    if (!this.chosenAgent) {
      swal("You must chose a property consultant", "", "error");
    } else {
      this.reservationService
        .assignToLead(res_id, this.chosenAgent.id)
        .subscribe(
          (data) => {
            console.log(data);
            swal("Woohoo!", "Assigned to user successfully!", "success");
            this.getReservation();
            this.slimLoadingBarService.complete();
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.complete();
          }
        );
    }
  }

  openAssignModal(unit_id) {}

  /***
   * end of assign modal
   */

  /**
   * start of edit selling price
   */

  openEditSellingPriceModal(reservation) {}

  closeEditSellingPriceModal(modal) {
    // this.selling_price_in_modal = '';
    this.selling_price_in_modal = this.reservation_details.unit_price;
    modal.close();
  }

  submiteditSellingPriceModal(reservation, modal) {
    // this.percentage = this.price_precentage;
    // this.reason = this.reason;
    // if (!this.percentage) swal("percentage can not be empty", "", "error");
    if (!this.reason) swal("reason can not be empty", "", "error");
    else {
      modal.close();
      const data = {
        type: this.type_extra_discount,
        value: this.value_extra_discount,
        reason: this.reason,
        selling_price: this.selling_price_in_modal,
      };
      this.slimLoadingBarService.start();
      this.reservationService.editSellingPrice(reservation.id, data).subscribe(
        (data: any) => {
          swal("Selling price changes successfully", "", "success");
          this.type_extra_discount = "percentage";
          this.value_extra_discount = "";
          this.reason = "";
          this.getReservation();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  /**
   * end of selling price
   */

  /**
   * Start of change selling date modal
   */

  openChangeSellingDateModal(reservation) {}

  closeChangeSellingDateModal() {}

  submitChangeSellingDateModal(reservation, modal) {
    if (!this.selling_date) swal("Selling date can not be empty", "", "error");
    else {
      const data = {
        selling_date: this.selling_date,
      };
      this.slimLoadingBarService.start();
      this.reservationService.changeSellingDate(reservation.id, data).subscribe(
        (data) => {
          modal.close();
          swal("Selling date changed successfully", "", "success");
          this.getReservation();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  /**
   * End of change selling date modal
   */

  /**
   * Start of change selling date modal
   */

  openChangeConfirmationDateModal(reservation) {}

  closeChangeConfirmationDateModal() {}

  submitConfirmationDateModal(reservation, modal) {
    if (!this.confirmation_date)
      swal("Confirmation date can not be empty", "", "error");
    else {
      const data = {
        confirmation_date: this.confirmation_date,
      };
      this.slimLoadingBarService.start();
      this.reservationService
        .changeConfirmationDate(reservation.id, data)
        .subscribe(
          (data) => {
            modal.close();
            swal("Confirmation date changed successfully", "", "success");
            this.getReservation();
          },
          (err) => this.errorHandlerService.handleErorr(err),
          () => this.slimLoadingBarService.complete()
        );
    }
  }

  /**
   * End of change selling date modal
   */

  /**
   * Start of Comment Modal
   * */
  openCommentModal(reservation) {}

  submitCommentModal(reservation_id, modal) {
    if (!this.commentReservation)
      swal("Error", "Comment can not be empty", "error");
    else {
      this.slimLoadingBarService.start();
      this.reservationService
        .addReservationComment(reservation_id, this.commentReservation)
        .subscribe(
          (data) => {
            modal.close();
            this.getReservation();
            swal("Woohoo!", "Comment have added succesfully!", "success");
          },
          (err) => this.errorHandlerService.handleErorr(err),
          () => this.slimLoadingBarService.complete()
        );
    }
  }

  closeCommentModal() {}

  openViewCommentModal(reservation) {}

  closeViewCommentModal() {}

  /**
   * End of Comment Modal
   */

  /**
   * Start of Installment Modal
   */

  createInstallmentForm() {
    this.installmentForm = this.fb.group({
      percentage: ["", Validators.required],
      slots: ["0", Validators.required],
      service_room_slots: ["0", Validators.required],
      service_room_with_bathroom_slots: ["0", Validators.required],
      type: ["", Validators.required],
      day: ["5", Validators.required],
      doc_type: ["PDF", Validators.required],
      installment_plan: ["Quarter", Validators.required],
      installment_delay: [""],
    });
  }

  openInstallmentModal(reservation) {}

  closeInstallmentModal() {}

  submitInstallmentModal(reservation, modal) {
    const data = this.installmentForm.value;
    data.r_serial = reservation.id;
    console.log(data);
    /* call back end point here and dismiss loader in success */
    // this.is_installment_modal_loading = true;
    modal.close();
    this.reservationService.installmentPdf(data).subscribe(
      (res: any) => {
        modal.close();
        console.log(res.url);
        window.open(res.url);
        this.getPaymentCollection(this.reservation_details.id);
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  /**
   * End of Installment Modal
   */

  /**
   * Start of accountant approve modal
   */

  accountantApproveModalOpen(reservation) {}

  accountantApproveModalClose() {}

  accountApprove(reservation, modal) {
    const isValid = this.validatingPayloadForAccountantApproveAndAddFine();
    if (!isValid) return;
    let payload: any = {
      amount_received:
        this.payment_type == "deposit"
          ? this.deposit_amount
          : this.reservation_details.total_down_payment,
      slip_number: this.slip_number,
      type: this.slip_type,
      lead_id: this.slip_customer,
      cheque_number: this.cheque_number,
      currency_code: this.currency_code,
      exchange_rate: this.exchange_rate,
      transaction_number: this.transaction_number,
    };
    console.log(this.slip_type);
    payload = {
      ...this.getPaylodForAccountantApproveAndAddFine(),
      ...payload,
    };
    if (this.isDateGreaterThanToday(this.collection_date)) {
      swal("request date can not be greater than today", "", "error");
      return;
    }
    this.slimLoadingBarService.start();
    this.reservationService
      .accountantApprove(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          this.getReservation();
          this.payment_type = "down_payment";
          this.deposit_amount = null;
          this.slimLoadingBarService.complete();
          modal.close();
          swal("success", "Accountant approved successfully", "success");
        },
        (err) => {
          this.slimLoadingBarService.reset();
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  getPaylodForAccountantApproveAndAddFine() {
    let payload: any = {};
    if (this.slip_type == 4 || this.slip_type == 2 || this.slip_type == 3) {
      payload.store_status = this.store_status;
      payload.bank_id = this.bank_id;
    }
    if (this.slip_type == 4) {
      payload.due_date = this.due_date;
    } else {
      payload.collection_date = this.collection_date;
    }
    if (this.payment_type == "deposit") {
      if (this.deposit_amount > this.reservation_details.total_down_payment) {
        swal(
          "error",
          "deposit amount is bigger than the down payment amount",
          "error"
        );
        return;
      } else if (!this.deposit_amount) {
        swal("error", "you must enter a deposit amount", "error");
        return;
      } else {
        payload.amount_received = this.deposit_amount;
      }
    }
    if (this.slip_type == 5) {
      payload.commission_settlement_user_id =
        this.commission_settlement_user_id;
    }
    if (this.slip_type == 6) {
      payload.share_holder_name = this.share_holder_name;
    }
    return payload;
  }

  validatingPayloadForAccountantApproveAndAddFine() {
    if (this.currency_code != "EGP" && !this.exchange_rate) {
      swal(
        "error",
        "Exchange Rate is needed if the currency is not EGP",
        "error"
      );
      return false;
    }
    if (this.slip_type == "5") {
      if (!this.commission_settlement_user_id) {
        swal(
          "Error",
          "Missing data, commission settlement user is a mandatory",
          "error"
        );
        return false;
      }
    }
    if (this.slip_type == "6") {
      if (!this.share_holder_name) {
        swal("Error", "Missing data, share holder is a mandatory", "error");
        return false;
      }
    }
    if (this.slip_type === "1") {
      if (!this.collection_date || !this.slip_customer || !this.slip_number) {
        console.log("1");
        console.log(this.collection_date);
        console.log(this.slip_customer);
        console.log(this.slip_number);
        swal(
          "Error",
          "Missing data, please fill all the required data",
          "error"
        );
        return false;
      }
    } else if (this.slip_type === "2" || this.slip_type === "3") {
      console.log(this.transaction_number);
      console.log(this.bank_id);
      console.log(this.store_status);
      console.log(this.collection_date);
      console.log(this.slip_customer);
      console.log(this.slip_number);
      if (
        !this.transaction_number ||
        !this.store_status ||
        !this.collection_date ||
        !this.slip_customer ||
        !this.slip_number
      ) {
        swal(
          "Error",
          "Missing data, please fill all the required data",
          "error"
        );
        return false;
      }
    } else if (this.slip_type === "4") {
      console.log(this.cheque_number);
      console.log(this.bank_id);
      console.log(this.due_date);
      console.log(this.slip_customer);
      console.log(this.slip_number);
      if (
        !this.cheque_number ||
        !this.bank_id ||
        !this.due_date ||
        !this.slip_customer ||
        !this.slip_number
      ) {
        swal(
          "Error",
          "Missing data, please fill all the required data",
          "error"
        );
        return false;
      }
    }
    return true;
  }

  addBankTransferFormData = {
    transfer_by: "",
    document_name: "",
    document_value: null,
  };

  addBankTransferModalOpen(form) {
    form.reset();
    this.addBankTransferFormData = {
      transfer_by: "",
      document_name: "",
      document_value: null,
    };
  }

  onBankTransferFileChange(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      this.file_name = file.name;
      reader.onload = () => {
        this.addBankTransferFormData.document_name = file.name;
        this.addBankTransferFormData.document_value = (
          reader.result as any as any
        ).split(",")[1];
      };
    }
  }

  addBankTransfer(modal) {
    if (
      !(
        this.addBankTransferFormData.transfer_by &&
        this.addBankTransferFormData.document_name &&
        this.addBankTransferFormData.document_value
      )
    ) {
      swal("error", "Please fill the form.", "error");
      return;
    }
    this.slimLoadingBarService.start();
    this.reservationService
      .addBankTransfer(
        this.reservation_details.id,
        this.addBankTransferFormData
      )
      .subscribe(
        (res: any) => {
          this.slimLoadingBarService.complete();
          modal.close();
          swal("success", "Bank Transfer Added Successfully.", "success");
        },
        (err) => {
          this.slimLoadingBarService.reset();
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  BanksTransfersFiles = [];

  ViewBankTransferModalOpen() {
    this.BanksTransfersFiles = [];
    this.slimLoadingBarService.start();
    this.reservationService
      .getBankTransfer(this.reservation_details.id)
      .subscribe(
        (res: any) => {
          this.BanksTransfersFiles = res;
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.slimLoadingBarService.reset();
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  // editPrice(last_price) {
  //   this.last_price = last_price;
  //   this.is_edit_mode_account_approve = true;
  // }

  // closeEditPrice(reservation_details) {
  //   console.log(reservation_details);
  //   reservation_details.unit_price = this.last_price;
  //   this.is_edit_mode_account_approve = false;
  // }

  editPriceUsingPercentage(event) {
    // console.log(+this.selling_price_in_modal);
    // if (this.price_precentage > 0) {
    //   this.selling_price_in_modal =
    //     ((+this.reservation_details.unit_price * +this.price_precentage) / 100) - +this.reservation_details.unit_price;
    // } else {
    //   this.selling_price_in_modal = this.reservation_details.unit_price;
    // }
  }

  sellingPriceChange(event) {
    // if (+this.selling_price_in_modal > 0) {
    //   this.price_precentage = (+this.selling_price_in_modal * 100) / +this.reservation_details.unit_price;
    // } else {
    //   this.price_precentage = 0;
    // }
  }

  checkNumber(event) {
    const arr = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
    console.log(event.key);
    if (arr.indexOf(+event.key) == -1) event.preventDefault();
  }

  /**
   * End of accountant approve modal
   */

  /***
   * start of first modal
   * */

  handleReceiptFile(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      console.log(file);
      this.file_name = file.name;
      reader.onload = () => {
        this.filesForm.get("receipt").patchValue({
          filename: file.name,
          filetype: file.type,
          value: (reader.result as any as any).split(",")[1],
        });
      };
    }
  }

  handleSignedFile(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      console.log(file);
      this.file_name2 = file.name;
      reader.onload = () => {
        this.filesForm.get("signed").patchValue({
          filename: file.name,
          filetype: file.type,
          value: (reader.result as any as any).split(",")[1],
        });
      };
    }
  }

  actionOnOpen(reservationId) {
    console.log(reservationId);
  }

  actionOnClose() {}

  actionOnSubmit(reservationId, modal) {
    this.slimLoadingBarService.start(() => {
      console.log("Loading complete");
    });
    const formModel = this.filesForm.value;
    console.log(formModel);
    const data: any = {
      id: reservationId,
      date: formModel.date,
    };
    if (formModel.receipt) {
      data.receipt = formModel.receipt.value;
      data.file_name = formModel.receipt.filename;
    }
    if (formModel.signed) {
      data.scan_url = formModel.signed.value;
      data.file_name2 = formModel.signed.filename;
    }
    console.log(data);
    this.reservationService.contractorApproved(data).subscribe(
      (data) => {
        console.log(data);
        this.getReservation();
        this.slimLoadingBarService.complete();
        modal.close();
        swal("Woohoo!", "Contractor Approved!", "success");
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  /***
   * end of first modal
   */

  /**
   * Start of Change Signature Modal
   */

  openChangeSignatureModal(reservation) {}

  closeChangeSignatureModal() {}

  submitChangeSignatureModal(reservation, modal) {
    if (!this.signature_date)
      swal("Signature date can not be empty", "", "error");
    else {
      this.slimLoadingBarService.start();
      this.reservationService
        .changeSignatureDate(reservation.id, this.submitCommentModal)
        .subscribe(
          (data: any) => {
            swal("Signature date Changed successfully", "", "success");
            modal.close();
          },
          (err) => this.errorHandlerService.handleErorr(err),
          () => this.slimLoadingBarService.complete()
        );
    }
  }

  /**
   * End of Change Signature Modal
   */

  /**
   * start of re-assign client modal
   */

  reAssignClientModalOpen(reservation) {}

  observableSource = (keyword: any): any => {
    const baseUrl: string = environment.api_base_url;
    const data = {
      keyword: keyword,
    };
    if (keyword) {
      return this.http
        .get(`${baseUrl}leads?keyword=${keyword}`)
        .map((res: any) => {
          console.log(res.data.length);
          if (res.data.length == 0) {
            const arr = [];
            return arr;
          } else {
            this.leadArrSerach = [];
            this.dataFromSearch = res.data;
            res.data.forEach((e) => {
              this.leadArrSerach.push(e.name);
            });
            return this.leadArrSerach;
          }
        });
    } else {
      return Observable.of([]);
    }
  };

  getLeadDetails(): any {
    console.log(this.chosenLead);
    if (!this.chosenLead) {
      swal("Lead name can not be empty!");
    } else {
      if (this.dataFromSearch.length == 0) {
        swal("No Lead with that name.");
      } else {
        let found = false;
        console.log(this.dataFromSearch);
        this.dataFromSearch.forEach((element) => {
          if (element.name == this.chosenLead) {
            this.chosenClient = {
              lead_id: element.id,
              lead_name: element.name,
              lead_address: element.address,
              lead_home_phone: element.phone_2,
              lead_phone: element.phone,
              lead_birthday: element.date_of_birth,
              lead_email: element.email,
              lead_work_address: element.work_address,
              lead_national_id: element.national_num,
              lead_is_residence: element.is_residence,
              // deal_type: element.lead_channel.name,
              deal_type: element.lead_channel
                ? element.lead_channel.name
                : null,
              lead_source: element.lead_source,
              ambassador_id: element.ambassador_id,
              broker_id: element.broker_id,
            };

            if (element.broker_id) {
              this.chosenClient = element.broker_id;
              delete this.chosenClient.ambassador_id;
            }
            if (element.ambassador_id) {
              this.chosenClient = element.ambassador_id;
              delete this.chosenClient.broker_id;
            }
            console.log(this.documentForm.value);
            if (!element.ambassador_id && element.broker_id) {
              this.chosenClient.deal_category = "Individual";
            }

            console.log(element, this.chosenLead);
            this.chosenLeadID = element.id;
            found = true;
            this.chosenLeadName = element.name;
            this.chosenLeadPhone = element.phone;
            this.chosenLeadAddress = element.address;
            this.chosenLeadBirthday = element.date_of_birth;
            // this.chosenLeadCivilRegistery =
            this.chosenLeadIssueDate = element.national_issue_date;
            // this.chosenLeadDistrict = element.
          }
        });
        if (!found) swal("No Lead with that name.");
      }
    }
  }

  searchLeadSelected(event) {
    console.log(event);
  }

  reAssignClientModalClose() {}

  reAssignClientSubmit(reservation, modal) {
    if (!this.chosenLeadID)
      swal(
        "Lead ID can not be empty",
        "click on get info button to get the lead id.",
        "error"
      );
    else if (!this.chosenLeadPhone)
      swal("Client Phone can not be empty", "", "error");
    else if (!this.chosenLeadName)
      swal("Client Name can not be empty", "", "error");
    else if (!this.chosenLeadReason)
      swal("Reason can not be empty", "", "error");
    else if (!this.chosenLeadNationalityID)
      swal("Client Nationality can not be empty", "", "error");
    else if (!this.chosenLeadNationality)
      swal("Client Nationality ID can not be empty", "", "error");
    else if (!this.chosenLeadDistrict)
      swal("Client Lead District can not be empty", "", "error");
    else if (!this.chosenLeadIssueDate)
      swal("Client Issue Date can not be empty", "", "error");
    else if (!this.chosenLeadCivilRegistery)
      swal("Client Civil Registery can not be empty", "", "error");
    else if (!this.chosenLeadBirthday)
      swal("Client Birthday can not be empty", "", "error");
    else if (!this.chosenLeadAddress)
      swal("Client Address can not be empty", "", "error");
    else {
      //call the back end point
      // let data = {
      //   lead_id: this.chosenLeadID,
      //   reservation_id: reservation.id,
      //   reason: this.chosenLeadReason,
      //   ...this.chosenClient
      // };
      // let data = {
      //   lead_id: this.chosenLeadID,
      //   reservation_id: reservation.id,
      //   reason: this.chosenLeadReason,
      //   lead_name: this.chosenLeadName,
      //   lead_phone: this.chosenLeadPhone,
      //   lead_national_id: this.chosenLeadNationalityID,
      //   lead_nationality: this.chosenLeadNationality,
      //   lead_district: this.chosenLeadDistrict,
      //   lead_issue_date: this.chosenLeadIssueDate,
      //   lead_civil_registry: this.chosenLeadCivilRegistery,
      //   lead_birthday: this.chosenLeadBirthday,
      //   lead_address: this.chosenLeadAddress,
      // };
      this.slimLoadingBarService.start();
      this.reservationService.reAssignToLead(this.chosenClient).subscribe(
        (res) => {
          this.getReservation();
          swal("Re-assign reservation to client successfully", "", "success");
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  /**
   * end of re-assign client modal
   */

  /***
   * start of Refund Admin Decline Modal
   */

  refundAdminDeclineModalSubmit(modal) {
    const payload = {
      refund_reason: this.refundReason,
    };
    if (!this.refundReason)
      swal("You have to provide a refund reason", "", "error");
    else {
      this.slimLoadingBarService.start();
      this.reservationService
        .adminDecline(this.reservation_details.id, JSON.stringify(payload))
        .subscribe(
          (data) => {
            swal("Woohoo!", "Declined Successfully!", "success");
            this.getReservation();
            modal.close();
          },
          (err) => this.errorHandlerService.handleErorr(err),
          () => this.slimLoadingBarService.complete()
        );
    }
  }

  /***
   * End of Refund Admin Decline Modal
   */

  /***
   * Start of division modal
   */

  createDivisionForm() {
    // this.divisionForm = this.fb.group({
    //   deal_type: ["", Validators.required],
    //   deal_source: [""],
    //   broker_id: [''],
    //   ambassador_id: ['']
    // });
  }

  deal_type_change() {
    // this.divisionForm.get("deal_type").valueChanges.subscribe((val) => {
    //   console.log(val);
    //   if (val == "Direct") {
    //     if (this.divisionForm.get("broker_id"))
    //       this.divisionForm.removeControl("broker_id");
    //     this.divisionForm.addControl(
    //       "deal_category",
    //       new FormControl("", Validators.required)
    //     );
    //     this.division_type_change();
    //     console.log(this.divisionForm.value);
    //   } else if (val == "In-Direct") {
    //     console.log(val);
    //     if (this.divisionForm.get("deal_category"))
    //       this.divisionForm.removeControl("deal_category");
    //     if (this.divisionForm.get("ambassador_id"))
    //       this.divisionForm.removeControl("ambassador_id");
    //     this.divisionForm.addControl(
    //       "broker_id",
    //       new FormControl("", Validators.required)
    //     );
    //   }
    // });
  }

  getAmbassadors() {
    this.slimLoadingBarService.start();
    this.userService.getAmbasdors().subscribe(
      (data: any) => {
        this.ambassadors = data;
        console.log(this.ambassadors);
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  getBrokers() {
    this.slimLoadingBarService.start();
    this.userService.getBorkers().subscribe(
      (data: any) => {
        this.brokers = data;
        console.log(this.brokers);
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  changeEventModalSubmit(modal, event_id) {
    const payload = {
      event_id,
    };

    this.slimLoadingBarService.start();
    this.reservationService
      .changeEvent(this.reservation_details.id, payload)
      .subscribe(
        (res) => {
          swal("Event changes successfully", "", "success");
          modal.close();
          this.getReservation();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  division_type_change() {
    // console.log("division_type_change changed");
    // this.divisionForm.get("deal_category").valueChanges.subscribe((val) => {
    //   if (val == "Ambassador") {
    //     console.log("Ambassador");
    //     this.divisionForm.addControl(
    //       "ambassador_id",
    //       new FormControl("", Validators.required)
    //     );
    //   } else if (val == "Individual") {
    //     console.log("Individual");
    //     // if (this.divisionForm.removeControl('ambassador_id'))
    //     //   this.divisionForm.removeControl('ambassador_id');
    //   }
    // });
  }

  divisionModalSubmit(modal) {
    const payload = this.divisionForm;
    // console.log(payload);
    payload.reservation_id = this.reservation_details.id;
    if (this.divisionForm.deal_type == "Direct") {
      this.divisionForm.ambassador_id = "";
      this.divisionForm.broker_id = "";
    } else {
      if (this.divisionForm.deal_source == "Broker") {
        this.divisionForm.ambassador_id = "";
      } else if (this.divisionForm.deal_source == "Ambassador") {
        this.divisionForm.broker_id = "";
      }
    }
    this.slimLoadingBarService.start();
    this.reservationService.changeDealType(payload).subscribe(
      (res) => {
        swal("Division changes successfully", "", "success");
        modal.close();
        this.getReservation();
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );

    // if (this.divisionForm)
    //   swal("Division can not be empty", "", "error");
    // else {
    //   this.slimLoadingBarService.start();
    //   this.reservationService.changeDealType(payload).subscribe(
    //     (res) => {
    //       swal("Division changes successfully", "", "success");
    //       modal.close();
    //       this.getReservation();
    //     },
    //     (err) => this.errorHandlerService.handleErorr(err),
    //     () => this.slimLoadingBarService.complete()
    //   );
    // }
  }

  divisionModalClose() {}

  divisionModalOpen() {}

  /***
   * End of division modal
   */

  /**
   * start of comission modal
   */

  commissionModalSubmit(modal) {
    if (!this.commission_date)
      swal("Commission date can not be empty", "", "error");
    else {
      const payload = {
        commission_date: this.commission_date,
        commission_to: this.commission_to,
      };
      this.slimLoadingBarService.start();
      this.reservationService
        .makeCommission(this.reservation_details.id, payload)
        .subscribe(
          (res) => {
            swal("Comission submited successfully", "", "success");
            modal.close();
            this.getReservation();
          },
          (err) => this.errorHandlerService.handleErorr(err),
          () => this.slimLoadingBarService.complete()
        );
    }
  }

  /**
   * end of comission modal
   */

  /**
   * start of Claim modal
   */

  claimModalSubmit(modal) {
    if (!this.claim_form.claim_date)
      swal("Claim date can not be empty", "", "error");
    else {
      const payload = {
        claim_date: this.claim_form.claim_date,
        claim_from: this.claim_form.claim_from,
      };
      this.slimLoadingBarService.start();
      this.reservationService
        .makeClaim(this.reservation_details.id, payload)
        .subscribe(
          (res) => {
            swal("Claim submited successfully", "", "success");
            modal.close();
            this.getReservation();
          },
          (err) => this.errorHandlerService.handleErorr(err),
          () => this.slimLoadingBarService.complete()
        );
    }
  }

  /**
   * end of Claim modal
   */

  garageSlotsModalOpen() {}

  garageSlotsModalClose() {}

  garageSlotsSubmit(modal) {
    if (!this.garageSlots)
      swal("Number of Garage slots must be entered", "", "error");
    else {
      const payload = {
        slots: this.garageSlots,
        rf_id: this.reservation_details.id,
      };
      this.slimLoadingBarService.start();
      this.reservationService.changeGarageSlots(payload).subscribe(
        (res: any) => {
          modal.close();
          swal("Chanegd number of Garage slots successfully", "", "success");
          this.getReservation();
        },
        (err) => console.log(err)
      );
    }
  }

  grantCommissionSubmit(value, modal) {
    const payload = {
      grant_commission: value,
    };
    this.slimLoadingBarService.start();
    this.reservationService
      .changeGrantCommission(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          modal.close();
          swal("Chanegd Grant Commission successfully", "", "success");
          this.getReservation();
        },
        (err) => console.log(err)
      );
  }

  SlotsModalOpen() {}

  SlotsModalClose() {}

  SlotsSubmit(modal) {
    if (!this.slots) swal("Number of slots must be entered", "", "error");
    else {
      const payload = {
        service_room_slots: this.slots.service_room_slots,
        service_room_with_bathroom_slots:
          this.slots.service_room_with_bathroom_slots,
        rf_id: this.reservation_details.id,
      };
      this.slimLoadingBarService.start();
      this.reservationService.changeSlots(payload).subscribe(
        (res: any) => {
          modal.close();
          swal("Chanegd number of slots successfully", "", "success");
          this.getReservation();
        },
        (err) => console.log(err)
      );
    }
  }

  addContractLogModalSubmit(modal, valid) {
    if (!valid) swal("Please fill the form", "", "error");
    else {
      this.addContractLog.reservation_id = this.reservationId;
      this.slimLoadingBarService.start();
      this.reservationService.addContractLog(this.addContractLog).subscribe(
        (res: any) => {
          modal.close();
          swal("Log Added", "", "success");
          this.getReservation();
        },
        (err) => console.log(err)
      );
    }
  }

  paymentTypeModalOpen() {}

  paymentTypeModalClose() {}

  paymentTypeSubmit(modal) {
    const payload = {
      payment_type: this.last_payment_type,
    };
    this.slimLoadingBarService.start();
    this.reservationService
      .changePaymentType(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          this.getReservation();
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }
  paymentTermModalOpen() {}

  paymentTermModalClose() {}
  paymentTermSubmit(modal) {
    const payload = this.paymentForm.value;
    console.log(payload);
    this.slimLoadingBarService.start();
    this.reservationService
      .changePaymentTerm(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          this.getReservation();
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  changePaymentMethod(event) {
    const paymentTermId = this.paymentForm.value.payment_term_id;
    console.log(this.methods, this.paymentForm.value.payment_term_id);
    const percentage = this.methods.find((meth) => {
      if (meth.id == paymentTermId) return meth;
    });
    console.log(percentage);
    this.percentage = percentage.downpayment_percentage;
  }

  overseasModalModalOpen() {}

  overseasModalModalClose() {}

  overseasModalSubmit(modal) {
    const payload = {
      is_overseas: this.is_overseas,
    };
    this.slimLoadingBarService.start();
    this.reservationService
      .changeOverseas(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          this.getReservation();
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  editLeadModalModalOpen(leadId) {
    this.customer_id = leadId;
    this.reservation_details.sharing_leads.forEach((lead) => {
      if (lead.lead_id == this.customer_id) {
        this.single_customer = lead;

        this.edit_lead_data.lead_id = this.single_customer.lead_id;
        this.edit_lead_data.lead_name = this.single_customer.lead_name;
        this.edit_lead_data.lead_phone = this.single_customer.lead_phone;
        this.edit_lead_data.lead_email = this.single_customer.lead_email;
        this.edit_lead_data.lead_national_id =
          this.single_customer.lead_national_id;
        this.edit_lead_data.lead_nationality =
          this.single_customer.lead_nationality;
        this.edit_lead_data.lead_other_phone =
          this.single_customer.lead_other_phone;
        this.edit_lead_data.lead_birthday = this.single_customer.lead_birthday;
        this.edit_lead_data.lead_address = this.single_customer.lead_address;
        this.edit_lead_data.lead_district = this.single_customer.lead_district;
        this.edit_lead_data.sharing_percentage =
          this.single_customer.sharing_percentage;
        this.edit_lead_data.customer_type = this.single_customer.customer_type;
      }
    });
  }

  editRepresentativeModalModalOpen(representativeId) {
    this.representative_id = representativeId;
    const representative = this.reservation_details.representative;
    if (this.reservation_details.representative) {
      this.addCustomerRepresentativeForm.power_of_attorney_date =
        representative.power_of_attorney_date;
      this.addCustomerRepresentativeForm.power_of_attorney_number =
        representative.power_of_attorney_number;
      this.addCustomerRepresentativeForm.power_of_attorney_office =
        representative.power_of_attorney_office;
      this.addCustomerRepresentativeForm.power_of_attorney_year =
        representative.power_of_attorney_year;
      this.addCustomerRepresentativeForm.representative_address =
        representative.representative_address;
      this.addCustomerRepresentativeForm.representative_department =
        representative.representative_department;
      this.addCustomerRepresentativeForm.representative_governorate =
        representative.representative_governorate;
      this.addCustomerRepresentativeForm.representative_name =
        representative.representative_name;
      this.addCustomerRepresentativeForm.representative_national_date =
        representative.representative_national_date;
      this.addCustomerRepresentativeForm.representative_national_governorate =
        representative.representative_national_governorate;
      this.addCustomerRepresentativeForm.representative_national_id =
        representative.representative_national_id;
      this.addCustomerRepresentativeForm.representative_national_office =
        representative.representative_national_office;
      this.addCustomerRepresentativeForm.representative_national_serial =
        representative.representative_national_serial;
    }
  }

  deleteLead(id) {
    swal({
      title: "Are you sure?",
      text: "You will delete this customer!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .deleteLead(this.reservation_details.id, id)
          .subscribe(
            (res: any) => {
              swal("Success", "Customer deleted successfully", "success");
              this.slimLoadingBarService.complete();
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  editLeadModalModalClose() {}

  editLeadModalSubmit(modal) {
    const payload = this.edit_lead_data;
    this.slimLoadingBarService.start();
    this.reservationService
      .editLeadInReservation(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          this.getReservation();
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  editRepresentativeModalSubmit(modal) {
    const payload = this.addCustomerRepresentativeForm;
    this.slimLoadingBarService.start();
    this.reservationService
      .editRepresentativeInReservation(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          this.getReservation();
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  cancelReservationReasonModalSubmit(modal) {
    const payload = {
      cancel_reason: this.cancel_reason,
      cancel_date: this.cancel_date,
    };
    this.slimLoadingBarService.start();
    this.reservationService
      .cancelReservationReasonDate(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          this.getReservation();
          modal.close();
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
  }

  onCloseTeamTreeModalModalClose() {}

  reactivateReservation() {
    swal({
      title: "Are you sure?",
      text: "Re-activate this reservation!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .reactivateReservation(this.reservation_details.id)
          .subscribe(
            (data) => {
              this.getReservation();
              swal("Woohoo!", "Re-activated succesfully!", "success");
              this.slimLoadingBarService.complete();
            },
            (err) => {
              this.errorHandlerService.handleErorr(err);
            },
            () => this.slimLoadingBarService.complete()
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  /** Start of Change Contract Type Modal */

  get contractTypeFromContractForm() {
    return this.contractForm.get("contract_type").value;
  }

  contractTypeModalOpen() {}

  contractTypeModalClose() {}

  contractTypeModalSubmit(modal) {
    const payload = this.contractForm.value;
    this.slimLoadingBarService.start();
    this.reservationService
      .changeContractType(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          this.getReservation();
          this.slimLoadingBarService.complete();
          modal.close();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.reset();
        }
      );
  }
  /** End of Change Contract Type Modal  */

  changePaymentMethodToContract(event) {
    // this.methods.forEach(element => {
    //   if (element.plan_name == event) {
    //     this.reservation_fees = element.downpayment_percentage;
    //   }
    // });
  }

  getPaymentTermsByProjectId(project_id) {
    console.log(project_id);
    this.userService.getProjectPaymentTerms({ project_id: project_id }).subscribe(
      (res) => {
        const arr: any = res;
        this.payment_plans = arr;
        console.log(this.payment_plans);
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  openUnitLAyoutGallery(images, index) {
    this._staticMasterPlanImages = [];
    for (let i = 0; i < images.length; i++) {
      const src = images[i].url;
      const caption = " ";
      const thumb = images[i].url;
      const album = {
        src: src,
        caption: caption,
        thumb: thumb,
      };
      this._staticMasterPlanImages.push(album);
    }
    console.log(this._staticMasterPlanImages);
    this._lightbox.open(this._staticMasterPlanImages, index);
  }

  prevSlide() {
    if (this.currentSlide == 0) {
      this.currentSlide =
        this.reservation_details.unit.layout_images.length - 1;
      return;
    } else if (this.currentSlide == 1) {
      this.currentSlide = 0;
      return;
    } else {
      this.currentSlide--;
      return;
    }
  }

  nextSlide() {
    if (
      this.currentSlide ==
      this.reservation_details.unit.layout_images.length - 1
    ) {
      this.currentSlide = 0;
      return;
    } else {
      this.currentSlide++;
      return;
    }
  }

  /*
   * Payment Collections Starts
   */
  pageChange(event) {
    console.log(event);
  }

  deleteSharedCommissionFromAgent(index) {
    this.sharedAgentsCommissions.removeAt(index);
  }

  overSeaContractSentModalOpen() {}

  overSeaContractSentModalubmit(modal) {
    if (!this.oversea_contract_sent_date) {
      swal("error", "enter oversea contract send date", "error");
    }
    const payload = {
      send_date: this.oversea_contract_sent_date,
    };
    this.slimLoadingBarService.start();
    swal({
      title: "Are you sure?",
      text: "Sent Oversea Contract!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .sentOverSeaContract(this.reservation_details.id, payload)
          .subscribe(
            (data) => {
              this.getReservation();
              swal(
                "Woohoo!",
                "Oversea contract date set successfully!",
                "success"
              );
              modal.close();
              this.slimLoadingBarService.complete();
            },
            (err) => {
              this.slimLoadingBarService.reset();
              this.errorHandlerService.handleErorr(err);
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  saveContractDate(contractEl: NgModel, modal) {
    if (!contractEl.value) {
      swal("error", "Enter Contract Date", "error");
    }
    const payload = {
      contract_date: contractEl.value,
    };
    this.slimLoadingBarService.start();
    swal({
      title: "Are you sure?",
      text: "Sent Contract Date!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .changeContractDate(this.reservation_details.id, payload)
          .subscribe(
            (data) => {
              this.getReservation();
              swal("Woohoo!", "Contract Date set successfully!", "success");
              modal.close();
              contractEl.control.patchValue("");
              this.slimLoadingBarService.complete();
            },
            (err) => {
              this.slimLoadingBarService.reset();
              this.errorHandlerService.handleErorr(err);
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  saveDeliveryDate(deliveryEl: NgModel, modal) {
    if (!deliveryEl.value) {
      swal("error", "Enter Delivery Date", "error");
    }
    const payload = {
      delivery_date: deliveryEl.value,
    };
    this.slimLoadingBarService.start();
    swal({
      title: "Are you sure?",
      text: "Sent Delivery Date!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .changeDeliveryDate(this.reservation_details.id, payload)
          .subscribe(
            (data) => {
              this.getReservation();
              swal("Woohoo!", "Delivery Date set successfully!", "success");
              modal.close();
              deliveryEl.control.patchValue("");
              this.slimLoadingBarService.complete();
            },
            (err) => {
              this.slimLoadingBarService.reset();
              this.errorHandlerService.handleErorr(err);
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  getPaymentCollection(reservation_id) {
    this.reservationService
      .getPaymentCollectionForAReservation(reservation_id)
      .subscribe(
        (res: any) => {
          this.payment_collections = res.map((c) => {
            if (c.receipts) {
              c.collect_types = Array.from(
                new Set(c.receipts.map((r) => r.type_string))
              ).join(", ");
            }
            c.db_date = c.date;
            return c;
          });
        },
        (err) => {
          console.log(err);
        }
      );
  }

  getFines(reservation_id) {
    this.reservationService
      .getReservationFines({
        filter_reservation: reservation_id,
        paginate: false,
      })
      .subscribe(
        (res: any) => {
          // remove data from fines
          this.fines = res.map((c) => {
            if (c.receipts) {
              c.collect_types = Array.from(
                new Set(c.receipts.map((r) => r.type_string))
              ).join(", ");
            }
            return c;
          });
        },
        (err) => {
          console.log(err);
        }
      );
  }

  acceptPaymentCollection(collection_id, index) {
    swal({
      title: "Are you sure?",
      text: "You will collect!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, collect it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        const payload = {
          status: "collected",
        };
        this.slimLoadingBarService.start();
        this.reservationService
          .updatePaymentCollectionStatus(collection_id, payload)
          .subscribe(
            (res: any) => {
              this.slimLoadingBarService.complete();
              // this.getPaymentCollections();
              this.payment_collections[index].status = "collected";
              swal("success", "Accepted Payment Successfully", "success");
            },
            (err) => {
              this.slimLoadingBarService.reset();
              this.errorHandlerService.handleErorr(err);
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  rejectPaymentCollection(collection_id, index) {
    swal({
      title: "Are you sure?",
      text: "You will reject!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, reject it!",
      cancelButtonText: "No, keep it",
    }).then((result) => {
      if (result.value) {
        const payload = {
          status: "bounced",
        };
        this.slimLoadingBarService.start();
        this.reservationService
          .updatePaymentCollectionStatus(collection_id, payload)
          .subscribe(
            (res: any) => {
              this.slimLoadingBarService.complete();
              // this.getPaymentCollections();
              this.payment_collections[index].status = "bounced";
              swal("success", "Bounced Payment Successfully", "success");
            },
            (err) => {
              this.slimLoadingBarService.reset();
              this.errorHandlerService.handleErorr(err);
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  onPaymentTypeChange() {
    if (this.payment_type == "down_payment") {
      this.deposit_amount = null;
    } else if (this.payment_type == "deposit") {
    }
  }
  /*
   * Payment Collections Ends
   */
  accountApproveSaving = false;

  completeDownPaymentModalOpen(reservation_details) {}
  completeDownPaymentModalClose() {}
  completeDownPaymentSubmit(reservation_details, completeDownPaymentModal) {
    // if ()
    if (!this.complete_down_payment_amount) {
      swal("error", "you must enter an amount first", "error");
      return;
    }
    if (this.slip_type == "5") {
      if (!this.commission_settlement_user_id) {
        swal(
          "Error",
          "Missing data, commission settlement user is a mandatory",
          "error"
        );
        return;
      }
    }
    if (this.slip_type == "6") {
      if (!this.share_holder_name) {
        swal("Error", "Missing data, share holder is a mandatory", "error");
        return;
      }
    }
    let payload: any = {
      amount_received:
        this.payment_type == "deposit"
          ? this.deposit_amount
          : this.complete_down_payment_amount,
      slip_number: this.slip_number,
      type: this.slip_type,
      lead_id: this.slip_customer,
    };
    if (this.slip_type == "4") {
      payload.cheque_number = this.cheque_number;
      payload.due_date = this.due_date;
      delete payload.date;
    } else {
      payload.date = this.collection_date;
    }
    if (
      this.slip_type == "2" ||
      this.slip_type == "3" ||
      this.slip_type == "4"
    ) {
      payload.bank_id = this.bank_id;
    }
    if (this.slip_type == "2" || this.slip_type == "3") {
      payload.store_status = this.store_status;
    }
    if (
      this.slip_type == "1" ||
      this.slip_type == "2" ||
      this.slip_type == "3"
    ) {
      payload.transaction_number = this.transaction_number;
    }
    if (this.slip_type == 5) {
      payload.commission_settlement_user_id =
        this.commission_settlement_user_id;
    }
    if (this.slip_type == 6) {
      payload.share_holder_name = this.share_holder_name;
    }
    if (
      this.collection_date &&
      this.isDateGreaterThanToday(this.collection_date)
    ) {
      swal("collection date can not be greater than today", "", "error");
      return;
    }
    this.slimLoadingBarService.start();
    this.accountApproveSaving = true;
    this.reservationService
      .completeDownPayment(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          this.complete_down_payment_amount = null;
          this.slimLoadingBarService.complete();
          swal("success", "", "success");
          completeDownPaymentModal.close();
          this.getReservation();
        },
        (err) => {
          this.slimLoadingBarService.reset();
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {
        this.accountApproveSaving = false;
      });
  }

  printPaymentsPdf() {
    this.slimLoadingBarService.start();
    this.projectsService
      .printPaymentsPdf(this.reservation_details.id)
      .subscribe(
        (res: any) => {
          this.projectsService.printHtml(res.url);
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.slimLoadingBarService.reset();
          console.log(err);
        }
      );
  }
  printChequeModalSubmit() {
    if (this.bank_id) {
      const payload = {
        cheque_template_id: this.bank_id,
      };
      this.slimLoadingBarService.start();
      this.projectsService
        .printBankCheques(this.reservation_details.id, payload)
        .subscribe(
          (res: any) => {
            this.projectsService.printHtml(res.url);
            this.slimLoadingBarService.complete();
          },
          (err) => {
            this.slimLoadingBarService.reset();
            console.log(err);
          }
        );
    }
  }

  printReciptModalSubmit(id) {
    this.slimLoadingBarService.start();
    this.projectsService.printRecipt(id).subscribe(
      (res: any) => {
        console.log(res);
        this.projectsService.printHtml(res);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.reset();
        console.log(err);
      }
    );
  }

  getChequesTempaltes() {
    this.projectsService.getBanks().subscribe(
      (res: any) => {
        this.banks = res;
      },
      (err) => {
        console.log(err);
      }
    );
  }

  cancelSendOverseasContract() {
    swal({
      title: "Are you sure?",
      text: "You will cancel send overseas contract!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .cancelSendOverseasContract(this.reservation_details.id)
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Cancelled send overseas contract successfully",
                "success"
              );
              this.slimLoadingBarService.complete();
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  cancelContractReview() {
    swal({
      title: "Are you sure?",
      text: "You will cancel contract review!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .cancelContractReview(this.reservation_details.id)
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Cancelled contract review successfully",
                "success"
              );
              this.slimLoadingBarService.complete();
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  cancelContractSignedByClient() {
    swal({
      title: "Are you sure?",
      text: "You will cancel contract signed by client!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .cancelContractSignedByClient(this.reservation_details.id)
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Cancelled contract signed by client successfully",
                "success"
              );
              this.slimLoadingBarService.complete();
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  cancelContractApprove() {
    swal({
      title: "Are you sure?",
      text: "You will cancel contract approve!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .cancelContractApprove(this.reservation_details.id)
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Cancelled contract approve successfully",
                "success"
              );
              this.slimLoadingBarService.complete();
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  cancelContractDelivered() {
    swal({
      title: "Are you sure?",
      text: "You will cancel contract delivered!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .cancelContractDelivered(this.reservation_details.id)
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Cancelled contract delivered successfully",
                "success"
              );
              this.slimLoadingBarService.complete();
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  downloadReservation() {
    this.slimLoadingBarService.start();
    this.reservationService
      .downloadReservation(this.reservation_details.id)
      .subscribe(
        (res: any) => {
          this.slimLoadingBarService.complete();
          window.open(res.url);
        },
        (err) => {
          this.slimLoadingBarService.reset();
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  downloadFile(url) {
    window.open(url, "_blank");
  }

  exportFinalPaymentPlan() {
    this.reservationService
      .exportFinalPaymentPlan(this.reservation_details.id)
      .subscribe(
        (res: any) => {
          this.downloadFile(res);
        },
        (err) => {}
      );
  }

  importFinalPaymentPlan() {
    this.reservationService
      .importFinalPaymentPlan(
        this.reservation_details.id,
        this.finalPaymentPlanFile
      )
      .subscribe(
        (res) =>
          swal("Success", "Payment plan uploaded successfully", "success"),
        (err) => this.errorHandlerService.handleErorr(err)
      );
  }

  onImportPlanChange(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      console.log(file);
      reader.onload = () => {
        this.finalPaymentPlanFile = {
          file_name: file.name,
          file: (<string>reader.result).split(",")[1],
        };
        this.importFinalPaymentPlan();
      };
    }
  }

  cancelCommission() {
    swal({
      title: "Are you sure?",
      text: "You will cancel comissions!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .cancelComissions(this.reservation_details.id)
          .subscribe(
            (res: any) => {
              swal("Success", "Cancelled comissions successfully", "success");
              this.slimLoadingBarService.complete();
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  cancelExtraDiscount() {
    swal({
      title: "Are you sure?",
      text: "You will cancel Extra Discount!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .cancelExtraDiscount(this.reservation_details.id)
          .subscribe(
            (res: any) => {
              swal(
                "Success",
                "Cancelled Extra Discount successfully",
                "success"
              );
              this.slimLoadingBarService.complete();
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  printFinalPaymentPlan() {
    this.slimLoadingBarService.start();
    this.reservationService
      .printFinalPaymentPlan(this.reservation_details.id)
      .subscribe(
        (res: any) => {
          this.slimLoadingBarService.complete();
          window.open(res.url);
        },
        (err) => {
          this.slimLoadingBarService.reset();
        }
      );
  }

  deleteFinalPaymentCollection() {
    swal({
      title: "Are you sure?",
      text: "You will delete the Final Payment Plan Collection!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .deleteFinalPaymentPlanCollection(this.reservation_details.id)
          .subscribe(
            (res: any) => {
              this.slimLoadingBarService.complete();
              swal(
                "Success",
                "Deleted Final Payment Plan Collection",
                "success"
              );
              this.getReservation();
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  checkPhoneValid(event: any) {
    const pattren = /[0-9\+]/;
    console.log(event.keyCode);
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattren.test(inputChar)) {
      event.preventDefault();
    }
  }

  customerSource = (keyword: any): any => {
    const baseUrl: string = environment.api_base_url;
    const data = {
      keyword: keyword,
    };
    if (keyword) {
      return this.http
        .get(`${baseUrl}leads?keyword=${keyword}&without_freezed=${true}`)
        .map((res: any) => {
          if (res.data.length == 0) {
            const arr = [];
            return arr;
          } else {
            this.arrSearch = [];
            this.customersData = res.data;
            res.data.forEach((e) => {
              this.arrSearch.push(`${e.name} / ${e.id}`);
            });
            return this.arrSearch;
          }
        });
    } else {
      return Observable.of([]);
    }
  };
  getCustomerDetails(reservation) {
    console.log("chooosen", this.customersData);

    if (!this.chosenCustomer) {
      swal("Lead name can not be empty!");
    } else {
      if (this.customersData.length == 0) {
        swal("No Lead with that name.");
      } else {
        let found = false;
        this.customersData.forEach((element) => {
          const leadId = this.chosenCustomer.replace(/\s/g, "").split("/")[1];
          if (element.id == leadId) {
            this.addCustomerForm.lead_id = element.id;
            found = true;

            this.addCustomerForm.lead_name = element.name;
            this.addCustomerForm.lead_phone = element.phone;
            this.addCustomerForm.lead_email = element.email;
            this.addCustomerForm.lead_national_id = element.national_num;
            this.addCustomerForm.lead_nationality = element.national_num;
            this.addCustomerForm.lead_other_phone = element.phone_2;
            this.addCustomerForm.lead_birthday = element.date_of_birth;
            this.addCustomerForm.lead_address = element.address;
            this.addCustomerForm.lead_district = element.location;
            this.addCustomerForm.sharing_percentage =
              element.sharing_percentage;
            this.addCustomerForm.customer_type = null;
          }
        });
        if (!found) swal("No Lead with that name.");
      }
    }
  }

  addCustomerModalOpen(reservation) {}

  addCustomerModalSubmit(reservation, modal) {
    if (!this.addCustomerForm.lead_id)
      swal(
        "Lead ID can not be empty",
        "Click on get info button to get the lead.",
        "error"
      );
    else if (!this.addCustomerForm.lead_phone)
      swal("Client Name can not be empty", "", "error");
    else if (!this.addCustomerForm.lead_name)
      swal("Client Phone can not be empty", "", "error");
    else {
      //call the back end point
      this.slimLoadingBarService.start();
      this.reservationService
        .addLead(reservation.id, this.addCustomerForm)
        .subscribe(
          (res) => {
            this.getReservation();
            swal("Customer added successfully", "", "success");
            this.chosenCustomer = "";

            //Set all object key to null after submission
            this.setNull(this.addCustomerForm);

            modal.close();
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
          },
          () => this.slimLoadingBarService.complete()
        );
    }
  }

  addCustomerRepresentativeModalSubmit(reservation, modal) {
    this.slimLoadingBarService.start();
    this.reservationService
      .addCustomerRepresentative(
        reservation.id,
        this.addCustomerRepresentativeForm
      )
      .subscribe(
        (res) => {
          this.getReservation();
          swal("Customer added successfully", "", "success");
          this.chosenCustomer = "";

          //Set all object key to null after submission
          this.setNull(this.addCustomerRepresentativeForm);

          modal.close();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        },
        () => this.slimLoadingBarService.complete()
      );
  }

  setNull(obj) {
    this.setAll(obj, null);
  }
  setAll(obj, val) {
    Object.keys(obj).forEach(function (index) {
      obj[index] = val;
    });
  }

  // ====== cheques book ======

  enablePaymentCollectionEdit(enable_or_disable: boolean): void {
    this.slimLoadingBarService.start();
    this.enable_edit_payment_collections = enable_or_disable;
    this.payment_collections = this.payment_collections.map((payment) => {
      if (
        payment.final_cheque_received ||
        payment.delivered_to_customer ||
        payment.status === "fully-collected" ||
        (payment.send_to_treasury &&
          payment.is_treasury_approve &&
          payment.partially_method === "4")
      ) {
        return {
          ...payment,
          can_edit: false,
          can_edit_location: false,
        };
      } else {
        return {
          ...payment,
          can_edit: enable_or_disable,
          can_edit_location: enable_or_disable,
        };
      }
    });
    console.log(this.payment_collections);
    if (enable_or_disable) {
      this.onChequeAmountChanged();
    } else {
      this.getPaymentCollection(this.reservationId);
    }
    this.slimLoadingBarService.complete();
  }

  // reminder
  oOpenEnableReminder(id, modal, type?) {
    if (id) this.current_active_cheque = id;
    if (type) this.enableRemiderType = type;
    else this.enableRemiderType = null;
    modal.open();
  }

  oOpenDisableReminder(id, modal, type?) {
    if (id) this.current_active_cheque = id;
    if (type) this.disableReminderType = type;
    else this.disableReminderType = null;
    modal.open();
  }

  enableSelectedReminder(modal) {
    const selectedCheques = this.payment_collections.filter(
      (list) => list.checked == true
    );
    if (selectedCheques.length == 0) {
      swal("warning", "There is no selected Cheques");
    } else {
      this.oOpenEnableReminder(null, modal, "multiple");
    }
  }

  disableSelectedReminder(modal) {
    const selectedCheques = this.payment_collections.filter(
      (list) => list.checked == true
    );
    if (selectedCheques.length == 0) {
      swal("warning", "There is no selected Cheques");
    } else {
      this.oOpenDisableReminder(null, modal, "multiple");
    }
  }

  // collect
  onOpenCollectCheque(payment, modal, type?) {
    if (payment && payment.id) this.current_active_cheque = payment.id;
    if (type) this.chequeCollectType = type;
    else this.chequeCollectType = null;
    console.log(this.chequeCollectType);
    if (payment) this.active_cheque_book_row = payment;
    console.log(this.active_cheque_book_row);
    this.collection_date = this.active_cheque_book_row.collection_date;
    this.collect_type = "fully-collected";
    this.partially_method = this.active_cheque_book_row.partially_method;
    modal.open();
    console.log(this.collect_type);
  }

  collectSelectedCheque(modal) {
    const selectedCheques = this.payment_collections.filter(
      (list) => list.checked == true
    );
    if (selectedCheques.length == 0) {
      swal("warning", "There is no selected Cheques");
    } else {
      this.collect_type = "fully-collected";
      this.onOpenCollectCheque(null, modal, "multiple");
    }
  }

  // collect fine
  onOpenCollectChequeFine(id, modal, type?) {
    if (id) this.current_active_cheque_fine = id;
    if (type) this.chequeCollectTypeFine = type;
    else this.chequeCollectTypeFine = null;
    console.log(this.chequeCollectTypeFine);
    modal.open();
  }

  collectSelectedChequeFine(modal) {
    const selectedFines = this.fines.filter((list) => list.checked == true);
    if (selectedFines.length == 0) {
      swal("warning", "There is no selected Fines");
    } else {
      this.collect_type = "fully-collected";
      this.onOpenCollectChequeFine(null, modal, "multiple");
    }
  }

  collectFinesModalSubmitting = false;
  submitCollectChequeFine(modal) {
    if (this.collectFinesModalSubmitting) return;
    let payload;
    if (this.chequeCollectTypeFine == "multiple") {
      const selectedFines = this.fines.filter((list) => list.checked == true);
      payload = {
        ids: selectedFines.map((cheque) => cheque.id),
        status: this.collect_type_fines,
        lead_id: this.chequeCollectCustomerFines,
        partially_method: this.partially_method_fines,
        collection_date: this.collection_date_fines,
        currency_code: this.currency_code,
      };
    } else {
      payload = {
        ids: [this.current_active_cheque_fine],
        status: this.collect_type_fines,
        lead_id: this.chequeCollectCustomerFines,
        partially_method: this.partially_method_fines,
        collection_date: this.collection_date_fines,
        currency_code: this.currency_code,
      };
      if (this.collect_type_fines == "partially-collected") {
        payload.is_partially_collect = true;

        payload.amount_received = this.cheque_amount_fines;
        if (payload.partially_method == "3") {
          payload.partially_data = this.partially_data_fines;
        }
      }
    }
    this.collectFinesModalSubmitting = true;
    this.slimLoadingBarService.start();
    this.reservationService
      .collectChequeFine(this.reservationId, payload)
      .subscribe(
        (res: any) => {
          swal("Woohoo!", "Collected!", "success");
          modal.close();
          this.collect_type_fines = null;
          this.current_active_cheque_fine = null;
          this.cheque_amount_fines = null;
          this.partially_method_fines = null;
          this.partially_data_fines = null;
          this.collection_date_fines = "";
          this.chequeCollectCustomerFines = "";
          this.getReservation();
          this.getFines(this.reservation_details.id);
          this.getPaymentCollection(this.reservation_details.id);
          this.onCheckAllToggleFines(false);
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {
        this.collectFinesModalSubmitting = false;
      });
  }

  cdb_form = {
    amount: 0,
    date: "",
  };

  // Add CDB Form
  openaddCDB() {
    this.cdb_form = {
      amount: 0,
      date: "",
    };
  }

  submitaddCDB(modal) {
    this.slimLoadingBarService.start();
    this.reservationService
      .addCDB(this.reservationId, this.cdb_form)
      .subscribe(
        (res: any) => {
          swal("Woohoo!", "Collected!", "success");
          modal.close();
          this.getPaymentCollection(this.reservationId);
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {
        this.slimLoadingBarService.complete();
      });
  }
  // reject
  onOpenRejectCheque(id, modal, type = "single", location_bounce?) {
    if (id) this.current_active_cheque = id;
    if (type) this.chequeRejectType = type;
    else this.chequeRejectType = null;
    this.store_status = this.store_banks.find(
      (a) => a.name == "Treasury Safe"
    ).id;
    console.log(this.chequeRejectType);
    modal.open();
  }

  // reject
  onOpenRejectChequeFine(id, modal, type?) {
    if (id) this.current_active_cheque_fine = id;
    if (type) this.chequeRejectTypeFine = type;
    else this.chequeRejectTypeFine = null;
    console.log(this.chequeRejectTypeFine);
    modal.open();
  }

  rejectSelectedCheque(modal) {
    const selectedCheques = this.payment_collections.filter(
      (list) => list.checked == true
    );
    if (selectedCheques.length == 0) {
      swal("warning", "There is no selected Cheques");
    } else {
      this.collect_type = "fully-collected";
      this.onOpenRejectCheque(null, modal, "multiple");
    }
  }

  onCheckAllToggle(event) {
    this.check_all = event;
    this.payment_collections.forEach((e) => {
      if (this.check_all) {
        e.checked = true;
      } else {
        e.checked = false;
      }
    });
  }

  onCheckAllToggleFines(event) {
    this.check_all = event;
    this.fines.forEach((e) => {
      if (this.check_all) {
        e.checked = true;
      } else {
        e.checked = false;
      }
    });
  }

  onBankBlur(event, index) {
    this.payment_collections.forEach((payment, payment_index) => {
      if (
        payment.status === "cancelled" ||
        payment.status === "fully-collected" ||
        payment.final_cheque_received
      )
        return;
      if (payment_index > index) {
        this.payment_collections[payment_index].bank_id =
          this.payment_collections[index].bank_id;
      }
    });
  }
  onStoreBankBlur(event, index) {
    this.payment_collections.forEach((payment, payment_index) => {
      if (payment.status === "cancelled") return;
      if (payment_index > index) {
        this.payment_collections[payment_index].store_status =
          this.payment_collections[index].store_status;
      }
    });
  }
  onPartiallyMethodBlur(event, index) {
    this.payment_collections.forEach((payment, payment_index) => {
      if (payment.status === "cancelled") return;
      if (payment_index > index) {
        this.payment_collections[payment_index].partially_method =
          this.payment_collections[index].partially_method;
      }
    });
  }

  onChequeNumberBlur(event, index) {
    if (typeof this.payment_collections[index].cheque_number == "number") {
      this.payment_collections.forEach((payment, payment_index) => {
        if (
          payment.status === "cancelled" ||
          payment.status === "fully-collected" ||
          payment.final_cheque_received
        )
          return;
        if (payment_index > index) {
          this.payment_collections[payment_index].cheque_number =
            this.payment_collections[payment_index - 1].cheque_number + 1;
        }
      });
    }
  }
  onOpenUploadScannedCheque(id, modal) {
    this.current_active_cheque = id;
    modal.open();
  }

  onOpenCheque(cheque, modal) {
    this.current_active_full_cheque = cheque;
    modal.open();
  }

  savePaymnetcollection() {
    this.disableSavePaymentCollection = true;
    this.slimLoadingBarService.start();
    this.projectsService
      .updateChequeBook(this.reservation_details.id, this.payment_collections)
      .subscribe(
        (res: any) => {
          this.disableSavePaymentCollection = false;
          this.enablePaymentCollectionEdit(false);
          this.getReservation();
          swal("Success", "", "success");
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.disableSavePaymentCollection = false;
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        }
      );
  }

  onChequeAmountChanged() {
    this.totalChequeBookAmount = 0;
    this.totalCDBAmount = 0;
    this.payment_collections.map((c, index) => {
      if (
        this.reason_exclude_from_calculation.includes(c.request_reason) &&
        (c.status === "recall-request" ||
          c.status === "pending-recall" ||
          c.status === "recall")
      ) {
        return;
      }
      if (
        c.status === "recall-cancelled" ||
        c.status === "pending-cancelled" ||
        c.status === "cancelled"
      ) {
        return;
      }
      if (c.installment_type === "Fine") return;
      if (
        c.installment_type == "Down Payment" ||
        c.installment_type == "Installment"
      ) {
        console.log("counting", index);
        this.totalChequeBookAmount += +c.amount + c.early_payment_discount || 0;
      } else if (c.installment_type == "CDB")
        this.totalCDBAmount += +c.amount || 0;
    }, 0);
  }

  DATE_FORMAT = "yyyy-MM-dd";
  onChequeDateChanged(event, index) {
    const date = parse(
      this.payment_collections[index].date,
      this.DATE_FORMAT,
      new Date()
    );
    const db_date = parse(
      this.payment_collections[index].db_date,
      this.DATE_FORMAT,
      new Date()
    );

    let day_of_month = getDate(date);
    console.log(day_of_month);

    const monthsDiff = differenceInCalendarMonths(date, db_date);
    this.payment_collections.forEach((payment, payment_index) => {
      if (payment.status === "cancelled") return;
      if (payment_index > index) {
        let current_date = parse(payment.db_date, this.DATE_FORMAT, new Date());
        current_date = setDate(current_date, 1);
        current_date = addMonths(current_date, monthsDiff);

        let last_day_of_month = getDate(lastDayOfMonth(current_date));

        current_date = setDate(
          current_date,
          day_of_month > last_day_of_month ? last_day_of_month : day_of_month
        );

        payment.date = format(current_date, this.DATE_FORMAT);
      }
    });
  }

  submitPrintPaymentCollectioModal(modal) {
    const payload = {
      developer_id: +this.developer_id,
      cheque_book_name: this.cheque_book_name,
      name_on_cheques: this.name_on_cheques,
    };
    this.slimLoadingBarService.start();
    this.projectsService
      .printChequBook(this.reservation_details.id, payload)
      .subscribe(
        (res: any) => {
          window.open(res.url);
          swal("Success", "", "success");
          this.slimLoadingBarService.complete();
          modal.close();
          this.getReservation();
          modal.close();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.complete();
        }
      );
  }

  submitEnableReminder(modal) {
    let payload;
    if (this.enableRemiderType == "multiple") {
      const selectedCheques = this.payment_collections.filter(
        (list) => list.checked == true
      );
      payload = {
        ids: selectedCheques.map((cheque) => cheque.id),
        send_reminder: 1,
        reminder_reason: this.reminder_reason,
      };
    } else {
      payload = {
        ids: [this.current_active_cheque],
        send_reminder: 1,
        reminder_reason: this.reminder_reason,
      };
    }
    this.slimLoadingBarService.start();
    this.reservationService
      .enableOrDisableReminderCheque(this.reservationId, payload)
      .subscribe(
        (res: any) => {
          modal.close();
          this.reminder_reason = "";
          this.getReservation();
          this.onCheckAllToggle(false);
          this.enableRemiderType = null;
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  submitDisableReminder(modal) {
    let payload;
    if (this.disableReminderType == "multiple") {
      const selectedCheques = this.payment_collections.filter(
        (list) => list.checked == true
      );
      payload = {
        ids: selectedCheques.map((cheque) => cheque.id),
        send_reminder: 0,
        reminder_reason: this.reminder_reason,
      };
    } else {
      payload = {
        ids: [this.current_active_cheque],
        send_reminder: 0,
        reminder_reason: this.reminder_reason,
      };
    }
    this.slimLoadingBarService.start();
    this.reservationService
      .enableOrDisableReminderCheque(this.reservationId, payload)
      .subscribe(
        (res: any) => {
          modal.close();
          this.reminder_reason = "";
          this.getReservation();
          this.onCheckAllToggle(false);
          this.disableReminderType = null;
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  submitRejectCheque(modal) {
    console.log(this.reject_reason);
    console.log(this.bounce_date);
    console.log(this.store_status);
    if (!this.reject_reason || !this.bounce_date || !this.store_status) {
      swal("Bounce Reason or Bounce Date or Location is empty", "", "error");
      return;
    }
    let payload: any = {
      ids: [this.current_active_cheque],
      status: "bounced",
      reject_reason: this.reject_reason,
      bounce_reason: this.reject_reason,
      reject_comment: this.reject_reason == "other" ? this.reject_comment : "",
    };
    if (!this.bounce_date) {
      swal("error", "bounce date required", "error");
      return;
    }
    if (!this.store_status) {
      swal("error", "Location required", "error");
      return;
    }
    payload.bounce_date = this.bounce_date;
    payload.store_status = this.store_status;
    this.slimLoadingBarService.start();
    this.reservationService
      .collectCheque(this.reservationId, payload)
      .subscribe(
        (res: any) => {
          modal.close();
          this.current_active_cheque = null;
          this.cheque_amount = null;
          this.reject_reason = null;
          this.reject_comment = null;
          this.getReservation();
          this.onCheckAllToggle(false);
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  cancle_formdata = {
    early_payment_discount: 0,
    cancel_for: "early_payment",
    date: "",
    partially_method: "",
    cheque_number: "",
    store_status: null,
    bank_id: null,
    currency_code: "EGP",
    transaction_number: "",
    due_date: "",
  };
  onOpenCancelCheque(id, modal) {
    this.current_active_cheque = id;
    modal.open();
  }

  cancelModalSubmitting = false;
  submitCancelCheque(modal) {
    if (this.cancelModalSubmitting) return;
    if (this.cancle_formdata.currency_code != "EGP" && !this.exchange_rate) {
      swal(
        "error",
        "Exchange Rate is needed if the currency is not EGP",
        "error"
      );
      return;
    }
    let payload;
    if (this.cancle_formdata.cancel_for === "under-collection") {
      payload = {
        ids: [this.current_active_cheque],
        status: "cancelled",
      };
    } else {
      payload = {
        ids: [this.current_active_cheque],
        status: "cancelled",
        early_payment_discount: this.cancle_formdata.early_payment_discount,
        date: this.cancle_formdata.date,
        partially_method: this.cancle_formdata.partially_method,
        currency_code: this.cancle_formdata.currency_code,
        bank_id: this.cancle_formdata.bank_id,
        store_status: this.cancle_formdata.store_status,
        exchange_rate: this.exchange_rate,
        cheque_number: this.cancle_formdata.cheque_number,
        transaction_number: this.cancle_formdata.transaction_number,
        due_date: this.cancle_formdata.due_date,
      };
    }

    this.collectModalSubmitting = true;
    this.slimLoadingBarService.start();
    this.reservationService
      .collectCheque(0, payload, this.filterForm.value)
      .subscribe(
        (res: any) => {
          this.cancle_formdata = {
            early_payment_discount: 0,
            cancel_for: "early_payment",
            date: "",
            partially_method: "",
            cheque_number: "",
            store_status: null,
            bank_id: null,
            currency_code: "EGP",
            transaction_number: "",
            due_date: "",
          };
          this.current_active_cheque = null;
          modal.close();
          this.getReservation();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {
        this.collectModalSubmitting = false;
      });
  }

  deleteFine(id) {
    swal({
      title: "Are you sure?",
      text: "You will delete this fine!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it.",
    }).then((result) => {
      if (result.value) {
        let payload = {
          ids: id,
        };
        this.slimLoadingBarService.start();
        this.reservationService
          .deleteReservationFine(this.reservation_details.id, payload)
          .subscribe(
            (res: any) => {
              swal("Success", "Deleted Fine successfully", "success");
              this.slimLoadingBarService.complete();
              this.getFines(this.reservation_details.id);
              this.getReservation();
              this.getPaymentCollection(this.reservation_details.id);
            },
            (err) => {
              this.slimLoadingBarService.reset();
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  submitRejectChequeFine(modal) {
    let payload;
    if (this.chequeRejectTypeFine == "multiple") {
      const selectedFines = this.fines.filter((list) => list.checked == true);
      payload = {
        ids: selectedFines.map((cheque) => cheque.id),
        status: "bounced",
        reject_reason: this.reject_reason_fine,
        reject_comment:
          this.reject_reason_fine == "other" ? this.reject_comment_fine : "",
      };
    } else {
      payload = {
        ids: [this.current_active_cheque_fine],
        status: "bounced",
        reject_reason: this.reject_reason_fine,
        reject_comment:
          this.reject_reason_fine == "other" ? this.reject_comment_fine : "",
      };
    }
    this.slimLoadingBarService.start();
    this.reservationService
      .collectChequeFine(this.reservationId, payload)
      .subscribe(
        (res: any) => {
          modal.close();
          this.current_active_cheque_fine = null;
          this.cheque_amount_fine = null;
          this.reject_reason_fine = null;
          this.reject_comment_fine = null;
          this.getReservation();
          this.onCheckAllToggle(false);
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      );
  }

  collectModalSubmitting = false;
  submitCollectCheque(modal) {
    if (this.currency_code != "EGP" && !this.exchange_rate) {
      swal(
        "error",
        "Exchange Rate is needed if the currency is not EGP",
        "error"
      );
      return;
    }
    if (this.collectModalSubmitting) return;
    let payload;
    if (this.chequeCollectType == "multiple") {
      const selectedCheques = this.payment_collections.filter(
        (list) => list.checked == true
      );
      payload = {
        ids: selectedCheques.map((cheque) => cheque.id),
        status: this.collect_type,
        lead_id: this.chequeCollectCustomer,
        partially_method: this.partially_method,
        collection_date: this.collection_date,
        exchange_rate: this.exchange_rate,
        currency_code: this.currency_code,
      };
    } else {
      payload = {
        ids: [this.current_active_cheque],
        status: this.collect_type,
        lead_id: this.chequeCollectCustomer,
        partially_method: this.partially_method,
        collection_date: this.collection_date,
        exchange_rate: this.exchange_rate,
        currency_code: this.currency_code,
      };
      if (this.collect_type == "partially-collected") {
        payload.amount_received = this.cheque_amount;
        if (payload.partially_method == "3") {
          payload.partially_data = this.partially_data;
        }
      }
    }
    if (
      this.collect_type === "partially-collected" &&
      this.partially_method != 4
    ) {
      payload.transaction_number = this.transaction_number;
    }
    if (this.isDateGreaterThanToday(this.collection_date)) {
      swal("collection date can not be greater than today", "", "error");
      return;
    }
    this.collectModalSubmitting = true;
    this.slimLoadingBarService.start();
    this.reservationService
      .collectCheque(this.reservationId, payload)
      .subscribe(
        (res: any) => {
          swal("Woohoo!", "Collected!", "success");
          modal.close();
          this.collect_type = null;
          this.current_active_cheque = null;
          this.cheque_amount = null;
          this.partially_method = null;
          this.partially_data = null;
          this.collection_date = "";
          this.chequeCollectCustomer = "";
          this.getReservation();
          this.onCheckAllToggle(false);
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {
        this.collectModalSubmitting = false;
      });
  }

  uploadScannedChequeSubmit(modal) {
    this.slimLoadingBarService.start(() => {
      console.log("Loading complete");
    });
    const formModel = Object.assign({}, this.uploadScannedChequeForm.value);
    console.log(formModel);
    if (!formModel.scannedCheque) {
      swal("Oops...", "Files can not be empty!", "error");
    } else {
      const data = {
        // receipt: formModel.receipt.value,
        // scan_url: formModel.signed.value,
        // id: reservationId,
        // file_name2: formModel.signed.filename,
        // file_name: formModel.receipt.filename,
        image_value: formModel.scannedCheque.value,
        image_name: formModel.scannedCheque.filename,
      };
      console.log(data);
      this.reservationService
        .uploadScannedCheque(this.current_active_cheque, data)
        .subscribe(
          (data) => {
            console.log(data);
            this.getReservation();
            this.getPaymentCollection(this.reservationId);
            this.slimLoadingBarService.complete();
            modal.close();
            this.uploadScannedChequeForm.reset();
            swal("Woohoo!", "Contractor Approved!", "success");
          },
          (err) => {
            this.errorHandlerService.handleErorr(err);
            this.slimLoadingBarService.complete();
          }
        );
    }
  }

  handleUploadScannedCheque(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      reader.readAsDataURL(file);
      console.log(file);
      this.file_name = file.name;
      reader.onload = () => {
        // this.filesForm.get("receipt").setValue({
        //   filename: file.name,
        //   filetype: file.type,
        //   value: (reader.result as any).split(",")[1],
        // });
        this.uploadScannedChequeForm.get("scannedCheque").setValue({
          filename: file.name,
          filetype: file.type,
          value: (reader.result as any).split(",")[1],
        });
      };
    }
  }

  printSelectedCheque() {
    const selectedCheques = this.payment_collections.filter(
      (list) => list.checked == true
    );
    const payload = {
      ids: selectedCheques.map((cheque) => cheque.id),
    };
    this.reservationService.printCheques(this.reservationId, payload).subscribe(
      (res: any) => {
        const WindowPrt = window.open(res.url, "", "");
        WindowPrt.focus();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  printCheque(id) {
    const payload = {
      ids: [id],
    };
    this.reservationService.printCheques(this.reservationId, payload).subscribe(
      (res: any) => {
        const WindowPrt = window.open(res.url, "", "");
        WindowPrt.focus();
      },
      (err) => {
        this.errorHandlerService.handleErorr(err);
        this.slimLoadingBarService.complete();
      }
    );
  }

  showCheque(id) {
    const payload = {
      ids: [id],
      print_status: 1,
    };
    this.reservationService
      .hideOrShowCheque(this.reservationId, payload)
      .subscribe(
        (res: any) => {
          this.getPaymentCollection(this.reservationId);
          this.slimLoadingBarService.complete();
          swal("success", "Show successfully", "success");
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.reset();
        }
      );
  }

  hideCheque(id) {
    const payload = {
      ids: [id],
      print_status: 0,
    };
    this.reservationService
      .hideOrShowCheque(this.reservationId, payload)
      .subscribe(
        (res: any) => {
          this.getPaymentCollection(this.reservationId);
          swal("success", "Hide successfully", "success");
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.reset();
        }
      );
  }

  deleteCheque(id) {
    let payload = {
      ids: [id],
    };
    this.slimLoadingBarService.start();
    this.reservationService.deleteCheque(payload).subscribe(
      (res) => {
        this.slimLoadingBarService.complete();
        swal("success", "Cheque deleted successfully", "success");
        this.getPaymentCollection(this.reservationId);
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  getdevelopers() {
    this.slimLoadingBarService.start();
    this.userService.getDevelopers().subscribe(
      (data: any) => {
        this.developers = data;
        console.log(this.developers);
      },
      (err) => {},
      () => this.slimLoadingBarService.complete()
    );
  }

  async uploadScanned(event: any, document_id: number, fileInput) {
    let scanned_document_files_uploads = [];
    let selectedFiles = event.target.files;
    let onParsingEnd = new Promise((resolve, reject) => {
      for (let i = 0; i < selectedFiles.length; i++) {
        let file = selectedFiles[i];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async () => {
          let attach = {
            name: file.name,
            type: file.type,
            src: (reader.result as any as any).split(",")[1],
          };
          await scanned_document_files_uploads.push(attach);
          if (i + 1 == selectedFiles.length)
            resolve(scanned_document_files_uploads);
        };
      }
    });
    onParsingEnd.then((data) => {
      console.log(data);
      this.slimLoadingBarService.start();
      this.reservationService
        .uploadScannedFiles(this.reservationId, document_id, {
          scanned_files: data,
        })
        .subscribe(
          (res) => {
            console.log(fileInput);
            fileInput.value = null;
            this.slimLoadingBarService.complete();
            this.getReservationsDocuments();
            swal("Success", "scanned document added successfully", "success");
          },
          (err) => {
            this.slimLoadingBarService.reset();
          }
        );
    });
  }

  applyScanned(id) {
    console.log(id);
    this.slimLoadingBarService.start();
    this.reservationService.applyScanned(this.reservationId, id).subscribe(
      (res) => {
        swal("Success", "apply scanned successfully", "success");
        this.slimLoadingBarService.complete();
        this.getReservationsDocuments();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  addChequeBook(modal) {
    this.slimLoadingBarService.start();
    this.reservationService
      .addCheque(this.reservationId, this.add_cheque)
      .subscribe(
        (res) => {
          this.slimLoadingBarService.complete();
          modal.close();
          swal("Success", "Cheque added successfully", "success");
          this.getPaymentCollection(this.reservationId);
        },
        (err) => {
          this.slimLoadingBarService.reset();
        }
      );
  }

  add_fineModal = {
    submitting: false,
    reservaton_id: "",
    payload: {
      amount: 0,
      num_days_late: 0,
      collection_cheque_id: null,
      fine_date: "",
      type: "",
    },
  };

  openDelayFineModal(modal, cheque) {
    this.add_fineModal = {
      submitting: false,
      reservaton_id: cheque.reservation_id,
      payload: {
        amount: 0,
        num_days_late: 0,
        collection_cheque_id: cheque.id,
        fine_date: "",
        type: "",
      },
    };
    modal.open();
  }

  submitting_add_fine = false;
  addDelayFineToCheque(modal) {
    if (!this.add_fineModal.payload.type) {
      swal("error", "You have to choose a type for the fine!", "error");
      return;
    }
    if (!this.add_fineModal.payload.amount) {
      swal("error", "You have to enter an amount for the fine!", "error");
      return;
    }
    if (!this.slip_type) {
      swal("error", "You have to choose a method for the fine!", "error");
      return;
    }
    if (!this.add_fineModal.payload.fine_date) {
      swal("error", "You have to enter a date for the fine!", "error");
      return;
    }
    if (this.add_fineModal.payload.amount <= 0) {
      swal("error", "You have to enter a valid amount for the fine!", "error");
      return;
    }
    const isValid = this.validatingPayloadForAccountantApproveAndAddFine();
    if (!isValid) return;
    this.add_fineModal.submitting = true;
    this.slimLoadingBarService.start();
    this.submitting_add_fine = true;
    const payload = {
      ...this.getPaylodForAccountantApproveAndAddFine(),
      ...this.add_fineModal.payload,
      slip_number: this.slip_number,
      partially_method: this.slip_type,
      cheque_number: this.cheque_number,
    };
    this.reservationService
      .addDelayFine(this.add_fineModal.reservaton_id, payload)
      .subscribe(
        (res: any) => {
          swal("Success", "", "success");
          this.getPaymentCollection(this.reservationId);
          this.getFines(this.reservationId);
          modal.close();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
        }
      )
      .add(() => {
        this.submitting_add_fine = false;
      });
  }

  onTypeChange(type) {
    switch (type) {
      case "1":
        this.cheque_number = undefined;
        this.due_date = undefined;
        break;
      case "2":
      case "3":
        this.due_date = undefined;
        break;
      case "4":
        this.store_status = undefined;
        this.collection_date = undefined;
        break;
    }
  }

  enableOrDisableChequeInputs(payment, index) {
    console.log(payment);
    switch (payment.partially_method) {
      case "1":
        this.payment_collections = this.payment_collections.map((item) => {
          if (item.id !== payment.id) return item;
          else {
            return {
              ...item,
              disable_location: true,
              disable_bank: true,
              bank_id: null,
              store_status: null,
            };
          }
        });
        break;
      case "4":
        this.payment_collections = this.payment_collections.map((item) => {
          if (item.id !== payment.id) return item;
          else {
            return {
              ...item,
              disable_location: true,
              disable_bank: false,
              store_status: null,
            };
          }
        });
        break;
      default:
        this.payment_collections = this.payment_collections.map((item) => {
          if (item.id !== payment.id) return item;
          else {
            return {
              ...item,
              disable_location: false,
              disable_bank: false,
            };
          }
        });
        break;
    }
    console.log(this.payment_collections);
    this.payment_collections = this.payment_collections.map(
      (curr_payment, payment_index) => {
        if (
          !curr_payment.can_edit ||
          payment_index <= index ||
          !this.ListEdits_inputs ||
          curr_payment.final_cheque_recived == 1 ||
          curr_payment.status == "fully_collected"
        )
          return curr_payment;
        return {
          ...curr_payment,
          partially_method: payment.partially_method,
        };
      }
    );
    // console.log(this.payment_collections);
  }

  finalChequeSelected() {
    const selectedCheques = this.payment_collections.filter(
      (list) => list.checked == true
    );
    const payload = {
      ids: selectedCheques.map((cheque) => cheque.id),
    };
    this.execFinalChequeRecieved(payload);
  }

  addBulkCheque(modal) {
    const selectedCheques = this.payment_collections.filter(
      (list) => list.checked == true
    );
    if (selectedCheques.length <= 1) {
      swal("you need to select at least two cheques", "", "error");
      return;
    }
    this.add_bulk_cheque_amount = this.payment_collections.reduce(
      (acc, curr) => acc + curr.amount,
      0
    );
    modal.open();
    // this.execFinalChequeRecieved(payload);
  }

  submitBulkChequeModal(modal) {
    if (!this.add_bulk_cheque_amount)
      swal("Error", "Amount can not be empty", "error");
    else {
      const payload = {
        ids: this.payment_collections
          .filter((list) => list.checked == true)
          .map((payment) => payment.id),
        amount: this.add_bulk_cheque_amount,
      };
      this.slimLoadingBarService.start();
      this.reservationService.addBulkCheque(payload).subscribe(
        (data) => {
          modal.close();
          this.getReservation();
          swal("Woohoo!", "Added bulk cheque succesfully!", "success");
        },
        (err) => this.errorHandlerService.handleErorr(err),
        () => this.slimLoadingBarService.complete()
      );
    }
  }

  finalChequeRecieved(payment) {
    const payload = {
      ids: [payment.id],
    };
    this.execFinalChequeRecieved(payload);
  }

  execFinalChequeRecieved(payload) {
    this.slimLoadingBarService.start();
    this.reservationService.finalChequeRecieved(payload).subscribe(
      (res) => {
        this.getPaymentCollection(this.reservation_details.id);
        swal("Success", "final cheque received successfully", "success");
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  deliveredToCustomer(payment) {
    if (payment.bulk_serial) {
      const paymentsWithSamelBulkSerial = this.payment_collections.filter(
        (list) =>
          list.bulk_serial == payment.bulk_serial && payment.id != list.id
      );
      const includedStatueses = [
        "cancelled",
        "bounced-cancelled",
        "recall-cancelled",
      ];
      const paymentWithValidStatus = paymentsWithSamelBulkSerial.filter(
        (list) => includedStatueses.includes(list.status)
      );
      if (
        paymentsWithSamelBulkSerial.length !== paymentWithValidStatus.length
      ) {
        swal(
          "error",
          "You can not deliver this cheque to customer, bulk cheque is not cancelled",
          "error"
        );
        return;
      }
    }
    const payload = {
      ids: [payment.id],
    };
    this.execDeliveredToCustomer(payload);
  }

  execDeliveredToCustomer(payload) {
    this.slimLoadingBarService.start();
    this.reservationService.deliveredToCustomer(payload).subscribe(
      (res) => {
        this.getPaymentCollection(this.reservation_details.id);
        swal("Success", "Delivered to Customer successfully", "success");
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  sendCourierDate(el: NgModel, modal) {
    if (!el.value) {
      swal("error", "Enter Send Courier Date", "error");
    }
    const payload = {
      date: el.value,
    };
    this.slimLoadingBarService.start();
    swal({
      title: "Are you sure?",
      text: "Send By Courier Date!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .sendCourierDate(this.reservation_details.id, payload)
          .subscribe(
            (data) => {
              this.getReservation();
              swal("Woohoo!", "Send By Courier set successfully!", "success");
              modal.close();
              el.control.patchValue("");
              this.slimLoadingBarService.complete();
            },
            (err) => {
              this.slimLoadingBarService.reset();
              this.errorHandlerService.handleErorr(err);
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  receviedFromCourier(el: NgModel, modal) {
    if (!el.value) {
      swal("error", "Enter Received From Courier Date", "error");
    }
    const payload = {
      date: el.value,
    };
    this.slimLoadingBarService.start();
    swal({
      title: "Are you sure?",
      text: "Received From Courier Date!",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.value) {
        this.slimLoadingBarService.start();
        this.reservationService
          .receviedFromCourier(this.reservation_details.id, payload)
          .subscribe(
            (data) => {
              this.getReservation();
              swal(
                "Woohoo!",
                "Received From Courier set successfully!",
                "success"
              );
              modal.close();
              el.control.patchValue("");
              this.slimLoadingBarService.complete();
            },
            (err) => {
              this.slimLoadingBarService.reset();
              this.errorHandlerService.handleErorr(err);
            }
          );
      } else if (result.dismiss) {
        swal("Cancelled", "", "error");
      }
    });
  }

  approvePaymentRequest(ids, type?, modal?) {
    console.log(type);
    let payload: any = {
      ids,
      type: type,
      request_reason: this.request_reason,
      request_date: this.request_date,
    };
    if (type === "recall") {
      if (!this.request_date) {
        swal("request date is required", "", "error");
        return;
      }
      if (!this.request_reason) {
        swal("request reason is required", "", "error");
        return;
      }
    }
    if (type === "cancelled") payload.cancelled_date = this.request_date;
    if (type) payload.type = type;
    if (type === "recall-request") {
      if (!this.request_date) {
        swal("request date is required", "", "error");
        return;
      }
    }
    if (type === "pending-recall" || type === "bounced") {
      if (!this.store_status) {
        swal("location is required", "", "error");
        return;
      }
      if (!this.request_date) {
        swal("request date is required", "", "error");
        return;
      }
      payload.store_status = this.store_status;
    }
    if (type == "pending-cancelled") {
      if (!this.request_reason || !this.request_date || !this.store_status) {
        swal("request date or reason is empty", "", "error");
        return;
      }
      payload.bounce_reason = this.request_reason;
      payload.bounce_date = this.request_date;
      payload.store_status = this.store_status;
    }
    if (type == "bounced") {
      payload.location = this.location_bounce;
      payload.bounce_reason = this.request_reason;
      if (this.isDateGreaterThanToday(this.request_date)) {
        swal("bounce date can not be greater than today", "", "error");
        return;
      }
      payload.store_status = this.store_banks.find(
        (bank) => bank.name === "Treasury Safe"
      ).id;
    }
    console.log(payload);
    this.slimLoadingBarService.start();
    this.reservationService.approvePaymentRequest(payload).subscribe(
      (res) => {
        swal("approved successfully", "", "success");
        this.getPaymentCollection(this.reservation_details.id);
        this.slimLoadingBarService.complete();
        if (modal) modal.close();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  approvePaymentRequestForRedposit(list, modal) {
    modal.open();
    this.active_cheque_book_row = list;
  }

  approvePaymentRequestForRedpositModalSubmit(modal) {
    if (!this.store_status || !this.redeposit_date) {
      swal("request date or location is required", "", "error");
      return;
    }
    let payload: any = {
      ids: [this.active_cheque_book_row.id],
      store_status: this.store_status,
      redeposit_date: this.redeposit_date,
    };
    console.log(payload);
    this.slimLoadingBarService.start();
    this.reservationService.approvePaymentRequest(payload).subscribe(
      (res) => {
        modal.close();
        swal("approved successfully", "", "success");
        this.getPaymentCollection(this.reservation_details.id);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  rejectPaymentRequest(ids) {
    let payload: any = {
      ids,
    };
    console.log(payload);
    this.slimLoadingBarService.start();
    this.reservationService.rejectPaymentRequest(payload).subscribe(
      (res) => {
        swal("rejected successfully", "", "success");
        this.getPaymentCollection(this.reservation_details.id);
        this.slimLoadingBarService.complete();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  eoiObservableSource = (keyword: any): any => {
    let baseUrl: string = environment.api_base_url;
    let data = {
      keyword: keyword,
    };
    if (keyword) {
      return this.http
        .get(`${baseUrl}eois/get_available_eois_to_link?serial=${keyword}`)
        .map((res: any) => {
          console.log(res.data.length);
          if (res.data.length == 0) {
            let arr = [];
            return arr;
          } else {
            this.eoisArrSearch = [];
            this.eoiDataFromSearch = res.data;
            res.data.forEach((e) => {
              this.eoisArrSearch.push(`${e.unit.serial} / ${e.id}`);
            });
            return this.eoisArrSearch;
          }
        });
    } else {
      return Observable.of([]);
    }
  };

  linkEoiModalSubmit(id, modal) {
    if (this.chosenEoi) {
      const payload = {
        eoi_id: this.chosenEoi.split(" / ")[1],
      };
      this.slimLoadingBarService.start();
      this.reservationService.linkEOIToReservation(id, payload).subscribe(
        (res) => {
          modal.close();
          this.chosenEoi = null;
          this.chosen_eoi = null;
          swal("Success", "Linked EOI Successfully", "success");
          this.slimLoadingBarService.complete();
        },
        (err) => {
          this.errorHandlerService.handleErorr(err);
          this.slimLoadingBarService.reset();
        }
      );
    }
  }

  getRejectReaasons() {
    this.slimLoadingBarService.start();
    this.reservationService.getAllRejectReasons().subscribe(
      (res: any) => {
        this.slimLoadingBarService.complete();
        this.reject_reasons = res;
        console.log("reasons : ", res);
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  makePaymentRequests(type, ids, modal?) {
    if (type === "Redeposit Request") {
      if (!this.request_date) {
        swal("request date or reason is empty", "", "error");
        return;
      }
    }
    if (type === "Recall Request") {
      if (!this.request_date || !this.request_reason) {
        swal("request date or reason is empty", "", "error");
        return;
      }
    }
    if (type === "Redeposit Request") {
      if (this.isDateGreaterThanToday(this.request_date)) {
        swal("request date can not be greater than today", "", "error");
        return;
      }
    }
    if (type === "Cancel Request" || type === "recall") {
      if (!this.request_date || !this.request_reason) {
        swal("request date or reason is empty", "", "error");
        return;
      }
    }
    if (type === "Cancel Request") {
      if (this.isDateGreaterThanToday(this.request_date)) {
        swal("request date can not be greater than today", "", "error");
        return;
      }
    }
    const payload = {
      ids,
      type: type,
      request_reason: this.request_reason,
      request_date: this.request_date,
    };
    console.log(payload);
    this.slimLoadingBarService.start();
    this.reservationService.makePaymentRequests(payload).subscribe(
      (res) => {
        swal("request made successfully", "", "success");
        this.getPaymentCollection(this.reservation_details.id);
        this.slimLoadingBarService.complete();
        if (modal) modal.close();
      },
      (err) => {
        this.slimLoadingBarService.reset();
      }
    );
  }

  openCancelRequest(modal, type, ids) {
    this.request_date = "";
    this.request_reason = "";
    this.request_type = type;
    this.request_ids = ids;
    modal.open();
  }

  openRecallRequest(modal, type, ids) {
    this.request_date = "";
    this.request_reason = "";
    this.request_type = type;
    this.request_ids = ids;
    modal.open();
  }

  openRedeopsitRequest(modal, type, ids) {
    this.request_date = "";
    this.request_reason = "";
    this.request_type = type;
    this.request_ids = ids;
    modal.open();
  }

  openApproveRecallRequest(modal, type, ids) {
    this.request_date = "";
    this.request_reason = "";
    this.request_type = type;
    this.request_ids = ids;
    console.log(type);
    modal.open();
  }

  openApproveRequestAsRecallModal(modal, type, ids, list) {
    this.request_date = "";
    this.request_reason = "";
    this.request_type = type;
    this.request_ids = ids;
    if (list.request_reason === "Early Payment") {
      this.request_reason = "Early Payment";
    }
    modal.open();
  }

  openApproveRequestAsCancelledModal(modal, type, ids) {
    this.request_date = "";
    this.request_reason = "";
    this.request_type = type;
    this.request_ids = ids;
    modal.open();
  }

  openApproveRequestAsBounceModal(modal, type, ids) {
    this.request_date = "";
    this.request_reason = "";
    this.request_type = type;
    this.request_ids = ids;
    this.store_status = this.store_banks.find(
      (a) => a.name == "Treasury Safe"
    ).id;
    modal.open();
  }

  approvePendingRecall(modal, type, ids) {
    this.request_date = "";
    this.request_reason = "";
    this.request_type = type;
    this.request_ids = ids;
    this.store_status = this.store_banks.find(
      (a) => a.name == "Treasury Safe"
    ).id;
    console.log(type);
    modal.open();
  }

  isDateGreaterThanToday(date) {
    const inputDate = new Date(date);
    const today = new Date();

    if (inputDate > today) {
      return true;
    }
    return false;
  }

  getNationalities() {
    this.userService.getNationalities().subscribe((res: any) => {
      this.nationalities = res;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/reservation-view/reservation-view.component.ts